import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  Json: { input: any; output: any };
};

export type ApplicationVersion = {
  ApplicationVersionReleaseNote?: Maybe<Array<Maybe<ApplicationVersionReleaseNote>>>;
  code?: Maybe<Scalars['Int']['output']>;
  isForce?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  storeAddress?: Maybe<Scalars['String']['output']>;
  updateMessage?: Maybe<Scalars['String']['output']>;
};

export type ApplicationVersionReleaseNote = {
  title?: Maybe<Scalars['String']['output']>;
};

export type ApproveUserInvitationOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type AssignTestByPublicLinkOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type AssignTestToTesterGroupInputs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AssignTestToTesterGroupOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type Category = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CategoryListFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Category>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Checkout = {
  url?: Maybe<Scalars['String']['output']>;
};

export type CheckoutOutput = {
  data?: Maybe<Checkout>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type CompleteTestInputs = {
  handHold: HandHoldPosition;
};

export type Country = {
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  iso?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateFigmaImportTokenDataOutput = {
  data?: Maybe<FigmaImportTokenDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type CreateFlowInputs = {
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CreateFlowMediaInputs = {
  flowId: Scalars['String']['input'];
  isFlowStartPage?: InputMaybe<Scalars['Boolean']['input']>;
  isTarget?: InputMaybe<Scalars['Boolean']['input']>;
  mediaId: Scalars['String']['input'];
};

export type CreateFlowMediaLinkInputs = {
  endX: Scalars['Float']['input'];
  endY: Scalars['Float']['input'];
  isFlowTap: Scalars['Boolean']['input'];
  linkToMediaId: Scalars['String']['input'];
  startX: Scalars['Float']['input'];
  startY: Scalars['Float']['input'];
};

export type CreateFlowMediasOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type CreateProductInputs = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  iconPath?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  osType: ProductOsType;
};

export type CreateProductMediaInputs = {
  description?: InputMaybe<Scalars['String']['input']>;
  imagePath: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductPersonaInputs = {
  behavior?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  fromAge?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  targetGender?: InputMaybe<TargetGender>;
  toAge?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSupportInputs = {
  description: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  type: SupportType;
};

export type CreateSupportOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type CreateTestGroupInputs = {
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestGroupMemberInputs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  testerUserId: Scalars['String']['input'];
};

export type CreateTestInputs = {
  description?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scenario?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestTaskInputs = {
  description: Scalars['String']['input'];
  flowId: Scalars['String']['input'];
  targetMediaId: Scalars['String']['input'];
};

export type CreateWorkspaceTesterInputs = {
  email: Scalars['String']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export enum DefaultHand {
  Left = 'LEFT',
  Right = 'RIGHT',
}

export type DeleteFlowMediaInputs = {
  flowId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mediaId: Scalars['String']['input'];
};

export type DeleteFlowMediaLinkOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteFlowMediaOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteFlowOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteProductMediaOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteProductOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteProductPersonaOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteTestGroupMember = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteTestGroupOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteTestOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteTestTaskOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeleteUserOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export enum DeviceType {
  Android = 'ANDROID',
  Iphone = 'IPHONE',
}

export type Emotions = {
  angry?: Maybe<Scalars['Float']['output']>;
  disgust?: Maybe<Scalars['Float']['output']>;
  fear?: Maybe<Scalars['Float']['output']>;
  happy?: Maybe<Scalars['Float']['output']>;
  neutral?: Maybe<Scalars['Float']['output']>;
  sad?: Maybe<Scalars['Float']['output']>;
  surprise?: Maybe<Scalars['Float']['output']>;
};

export type FigmaImportTokenDataOutput = {
  token?: Maybe<Scalars['String']['output']>;
  validFor?: Maybe<Scalars['Int']['output']>;
};

export enum FileUploadType {
  Image = 'IMAGE',
  Screen = 'SCREEN',
  Video = 'VIDEO',
}

export type Flow = {
  id?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  medias?: Maybe<Array<Maybe<FlowMedia>>>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FlowStatus>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FlowListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Flow>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FlowMedia = {
  id?: Maybe<Scalars['String']['output']>;
  isFlowStartPage?: Maybe<Scalars['Boolean']['output']>;
  isTarget?: Maybe<Scalars['Boolean']['output']>;
  links?: Maybe<Array<Maybe<FlowMediaLink>>>;
  media?: Maybe<ProductMedia>;
};

export type FlowMediaLink = {
  endX?: Maybe<Scalars['Float']['output']>;
  endY?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isFlowTap?: Maybe<Scalars['Boolean']['output']>;
  linkToMedia?: Maybe<ProductMedia>;
  startX?: Maybe<Scalars['Float']['output']>;
  startY?: Maybe<Scalars['Float']['output']>;
};

export type FlowMediaListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<FlowMedia>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum FlowStatus {
  Archived = 'ARCHIVED',
  Available = 'AVAILABLE',
  Locked = 'LOCKED',
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
}

export type GenerateTaskByAiOutput = {
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GeneratedMediaHeatmapOutput = {
  firstPoint?: Maybe<HeatmapPoint>;
  hotPoints?: Maybe<Array<Maybe<HeatmapPoint>>>;
};

export type GetApplicationVersionOutput = {
  data?: Maybe<ApplicationVersion>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetDefaultHandReportOutputData = {
  LEFT?: Maybe<Scalars['Float']['output']>;
  RIGHT?: Maybe<Scalars['Float']['output']>;
};

export type GetDeviceTypeReportOutputData = {
  ANDROID?: Maybe<Scalars['Float']['output']>;
  IPHONE?: Maybe<Scalars['Float']['output']>;
};

export type GetDuidOutput = {
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetFlowMediaFilters = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GetFlowsFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GetGenderReportOutputData = {
  FEMALE?: Maybe<Scalars['Float']['output']>;
  MALE?: Maybe<Scalars['Float']['output']>;
  NON_BINARY?: Maybe<Scalars['Float']['output']>;
};

export type GetHandHoldPositionReportFullObject = {
  CRADLED?: Maybe<GetHandPositionReportObjectOutputData>;
  HOLD_AND_TOUCH?: Maybe<GetHandPositionReportObjectOutputData>;
  ONE_HAND_FIRST_ORDER?: Maybe<GetHandPositionReportObjectOutputData>;
  ONE_HAND_SECOND_ORDER?: Maybe<GetHandPositionReportObjectOutputData>;
  TWO_HANDS_LANDSCAPE?: Maybe<GetHandPositionReportObjectOutputData>;
  TWO_HANDS_PORTRAIT?: Maybe<GetHandPositionReportObjectOutputData>;
};

export type GetHandPositionReportObjectOutputData = {
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type GetInvoiceOutput = {
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetMediaSystemGeneratedHeatmapOutput = {
  data?: Maybe<GeneratedMediaHeatmapOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetPaymentOutput = {
  data?: Maybe<Payment>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetPresignedUrlOutput = {
  data?: Maybe<PresignedUrl>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetProductsFilters = {
  osType?: InputMaybe<ProductOsType>;
  status?: InputMaybe<ProductStatus>;
};

export type GetResultInfoMediasOutput = {
  isFlowStartPage?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<ProductMedia>;
};

export type GetStudyTaskSuccessRateDataStatistics = {
  successCount?: Maybe<Scalars['Int']['output']>;
  successRate?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GetStudyTaskSuccessRateDataStructure = {
  statistics?: Maybe<GetStudyTaskSuccessRateDataStatistics>;
  task?: Maybe<Task>;
};

export type GetStudyTaskSuccessRateReportOutput = {
  data?: Maybe<Array<Maybe<GetStudyTaskSuccessRateDataStructure>>>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetSubscriptionPlanFilters = {
  type?: InputMaybe<SubscriptionPlanType>;
};

export type GetSupportOutput = {
  data?: Maybe<SupportListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetSupportsFilters = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetTestGroupMembersFilters = {
  groupId?: InputMaybe<Scalars['String']['input']>;
};

export type GetTestIssuesFilters = {
  issueCategory?: InputMaybe<IssueCategory>;
  issuePriority?: InputMaybe<IssuePriority>;
  issueType?: InputMaybe<IssueType>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  testerId?: InputMaybe<Scalars['String']['input']>;
};

export type GetTestIssuesSummaryFilters = {
  issueType?: InputMaybe<IssueType>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type GetTestSessionReportInputs = {
  actionStatus?: InputMaybe<Array<InputMaybe<TesterUserTestActionStatus>>>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  testId?: InputMaybe<Scalars['String']['input']>;
};

export type GetTestSessionReportListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<TesterTest>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GetTestSessionReportOutput = {
  data?: Maybe<GetTestSessionReportListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetTesterReportOutput = {
  data?: Maybe<GetTesterReportOutputType>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetTesterReportOutputType = {
  age?: Maybe<Scalars['Json']['output']>;
  defaultHand?: Maybe<GetDefaultHandReportOutputData>;
  deviceType?: Maybe<GetDeviceTypeReportOutputData>;
  gender?: Maybe<GetGenderReportOutputData>;
  handHoldPosition?: Maybe<GetHandHoldPositionReportFullObject>;
};

export type GetTesterTestFullSwipeReportListOutput = {
  direction?: Maybe<SwipeDirection>;
  endX?: Maybe<Scalars['Float']['output']>;
  endY?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  startX?: Maybe<Scalars['Float']['output']>;
  startY?: Maybe<Scalars['Float']['output']>;
};

export type GetTesterTestFullSwipeReportOutput = {
  data?: Maybe<Array<Maybe<GetTesterTestFullSwipeReportListOutput>>>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetTesterTestFullTapReportListOutput = {
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<TapType>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type GetTesterTestFullTapReportOutput = {
  data?: Maybe<Array<Maybe<GetTesterTestFullTapReportListOutput>>>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetTesterTestReportInfoOutput = {
  data?: Maybe<GetTesterTestReportResultInfoOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetTesterTestReportOutput = {
  data?: Maybe<Array<Maybe<GetTesterTestResultOutput>>>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetTesterTestReportResultInfoOutput = {
  medias?: Maybe<Array<Maybe<GetResultInfoMediasOutput>>>;
  testers?: Maybe<Array<Maybe<TesterUser>>>;
};

export type GetTesterTestResultOutput = {
  fullName?: Maybe<Scalars['String']['output']>;
  task?: Maybe<Task>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
};

export type GetTesterTestsFilters = {
  actionStatus: Array<InputMaybe<TesterUserTestActionStatus>>;
};

export type GetTestsFilters = {
  progressStatus?: InputMaybe<TestProgressStatus>;
};

export type GetUploadPresignedUrlInputs = {
  extension: Scalars['String']['input'];
};

export type GetUserFilters = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserInvitationsFilters = {
  email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserInvitationListStatus>;
};

export type GetUserInvitationsOutput = {
  data?: Maybe<UserInvitationListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetUsersOutput = {
  data?: Maybe<UserListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetVideoEmotionsReportOutput = {
  data?: Maybe<GetVideoEmotionsReportOutputDataStructure>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetVideoEmotionsReportOutputDataStructure = {
  emotions?: Maybe<Emotions>;
  testId?: Maybe<Scalars['String']['output']>;
};

export type GetWorkspaceStatisticsOutput = {
  data?: Maybe<WorkspaceStatisticsOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export enum HandHoldPosition {
  Cradled = 'CRADLED',
  HoldAndTouch = 'HOLD_AND_TOUCH',
  OneHandFirstOrder = 'ONE_HAND_FIRST_ORDER',
  OneHandSecondOrder = 'ONE_HAND_SECOND_ORDER',
  TwoHandsLandscape = 'TWO_HANDS_LANDSCAPE',
  TwoHandsPortrait = 'TWO_HANDS_PORTRAIT',
}

export enum HandSize {
  AdultExtraLarge = 'ADULT_EXTRA_LARGE',
  AdultLarge = 'ADULT_LARGE',
  AdultMedium = 'ADULT_MEDIUM',
  AdultSmall = 'ADULT_SMALL',
  JuniorLarge = 'JUNIOR_LARGE',
  JuniorSmall = 'JUNIOR_SMALL',
  YouthLarge = 'YOUTH_LARGE',
  YouthSmall = 'YOUTH_SMALL',
}

export type HeatmapPoint = {
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export enum ImageSource {
  Figma = 'FIGMA',
  Invision = 'INVISION',
  Local = 'LOCAL',
  Sketch = 'SKETCH',
}

export enum IssueCategory {
  Accessibility = 'ACCESSIBILITY',
  CognitiveLoad = 'COGNITIVE_LOAD',
  Color = 'COLOR',
  Consistency = 'CONSISTENCY',
  ContentUxWriting = 'CONTENT_UX_WRITING',
  FormInput = 'FORM_INPUT',
  Hierarchy = 'HIERARCHY',
  Icons = 'ICONS',
  Imagery = 'IMAGERY',
  Interaction = 'INTERACTION',
  Layout = 'LAYOUT',
  Navigation = 'NAVIGATION',
  Type = 'TYPE',
  Visual = 'VISUAL',
}

export enum IssuePriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum IssueType {
  Accessibility = 'ACCESSIBILITY',
  Error = 'ERROR',
  Feedback = 'FEEDBACK',
  Findability = 'FINDABILITY',
  Functionality = 'FUNCTIONALITY',
  Improvement = 'IMPROVEMENT',
  Issue = 'ISSUE',
  PainPoint = 'PAIN_POINT',
  Prevention = 'PREVENTION',
  Recommendation = 'RECOMMENDATION',
  UsabilityBasedOnGuidelines = 'USABILITY_BASED_ON_GUIDELINES',
  UserNeed = 'USER_NEED',
}

export type ItemStatisticsType = {
  available?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type LoginDataOutput = {
  at?: Maybe<Scalars['String']['output']>;
  rt?: Maybe<Scalars['String']['output']>;
};

export type LoginOutput = {
  data?: Maybe<LoginDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type LogoutOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  approveUserInvitation?: Maybe<ApproveUserInvitationOutput>;
  assignTestByPublicLink?: Maybe<AssignTestByPublicLinkOutput>;
  assignTestToTesterGroup?: Maybe<AssignTestToTesterGroupOutput>;
  cancelTesterTest?: Maybe<TestChangeStatusOutput>;
  completeTesterTest?: Maybe<TestChangeStatusOutput>;
  createFigmaImportToken?: Maybe<CreateFigmaImportTokenDataOutput>;
  createFlow?: Maybe<SingularFlowOutput>;
  createFlowMedia?: Maybe<SingularFlowMediaOutput>;
  createFlowMediaLink?: Maybe<SingularFlowMediaLinkOutput>;
  createFlowMedias?: Maybe<CreateFlowMediasOutput>;
  createProduct?: Maybe<SingularProductOutput>;
  createProductMedia?: Maybe<SingularProductMediaOutput>;
  createProductPersona?: Maybe<SingularProductPersonaOutput>;
  createSupport?: Maybe<CreateSupportOutput>;
  createTest?: Maybe<SingularTestOutput>;
  createTestGroup?: Maybe<SingularTestGroupOutput>;
  createTestGroupMember?: Maybe<SingularTestGroupMemberOutput>;
  createTestTask?: Maybe<SingularTestTaskOutput>;
  createWorkspaceTester?: Maybe<DeleteTestGroupMember>;
  deleteFlow?: Maybe<DeleteFlowOutput>;
  deleteFlowMedia?: Maybe<DeleteFlowMediaOutput>;
  deleteFlowMediaLink?: Maybe<DeleteFlowMediaLinkOutput>;
  deleteProduct?: Maybe<DeleteProductOutput>;
  deleteProductMedia?: Maybe<DeleteProductMediaOutput>;
  deleteProductPersona?: Maybe<DeleteProductPersonaOutput>;
  deleteTest?: Maybe<DeleteTestOutput>;
  deleteTestGroup?: Maybe<SingularTestGroupOutput>;
  deleteTestGroupMember?: Maybe<DeleteTestGroupMember>;
  deleteTestTask?: Maybe<DeleteTestTaskOutput>;
  deleteTesterUserAccount?: Maybe<DeleteUserOutput>;
  finishTest?: Maybe<SingularTestOutput>;
  getMediaSystemGeneratedHeatMap?: Maybe<GetMediaSystemGeneratedHeatmapOutput>;
  logout?: Maybe<LogoutOutput>;
  pauseTest?: Maybe<SingularTestOutput>;
  refreshToken?: Maybe<LoginOutput>;
  resendTesterInvitation?: Maybe<ResendTesterInvitationOutput>;
  startTest?: Maybe<SingularTestOutput>;
  startTesterTest?: Maybe<TestChangeStatusOutput>;
  stopTest?: Maybe<SingularTestOutput>;
  submitSwipeTestResult?: Maybe<SubmitResultOutput>;
  submitTapTestResult?: Maybe<SubmitResultOutput>;
  submitTestMediaTrace?: Maybe<TestChangeStatusOutput>;
  submitTestVideoRecording?: Maybe<SubmitVideoResultOutput>;
  testerUserFetchOrCreate?: Maybe<SingularTestUserOutput>;
  testerUserRefreshToken?: Maybe<TesterLoginOutput>;
  testerUserRegister?: Maybe<TesterLoginOutput>;
  testerUserUpdateProfile?: Maybe<TesterLoginOutput>;
  testerUserlogout?: Maybe<TesterUserLogoutOutput>;
  updateFlow?: Maybe<SingularFlowOutput>;
  updateFlowMedia?: Maybe<SingularFlowMediaOutput>;
  updateFlowMediaLink?: Maybe<SingularFlowMediaLinkOutput>;
  updateFlowMedias?: Maybe<UpdateFlowMediasOutput>;
  updateProduct?: Maybe<SingularProductOutput>;
  updateProductMedia?: Maybe<SingularProductMediaOutput>;
  updateProductPersona?: Maybe<SingularProductPersonaOutput>;
  updateProfile?: Maybe<LoginOutput>;
  updateTest?: Maybe<SingularTestOutput>;
  updateTestGroup?: Maybe<SingularTestGroupOutput>;
  updateTestTask?: Maybe<SingularTestTaskOutput>;
  updateWorkspace?: Maybe<SingularWorkspaceOutput>;
};

export type MutationApproveUserInvitationArgs = {
  id: Scalars['String']['input'];
};

export type MutationAssignTestByPublicLinkArgs = {
  code: Scalars['String']['input'];
};

export type MutationAssignTestToTesterGroupArgs = {
  data?: InputMaybe<AssignTestToTesterGroupInputs>;
  productId: Scalars['String']['input'];
  taskIds: Array<InputMaybe<Scalars['String']['input']>>;
  testId: Scalars['String']['input'];
};

export type MutationCancelTesterTestArgs = {
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type MutationCompleteTesterTestArgs = {
  data: CompleteTestInputs;
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type MutationCreateFigmaImportTokenArgs = {
  productId: Scalars['String']['input'];
};

export type MutationCreateFlowArgs = {
  data: CreateFlowInputs;
  productId: Scalars['String']['input'];
};

export type MutationCreateFlowMediaArgs = {
  data: CreateFlowMediaInputs;
  productId: Scalars['String']['input'];
};

export type MutationCreateFlowMediaLinkArgs = {
  data: CreateFlowMediaLinkInputs;
  flowMediaId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationCreateFlowMediasArgs = {
  data: Array<InputMaybe<CreateFlowMediaInputs>>;
  productId: Scalars['String']['input'];
};

export type MutationCreateProductArgs = {
  data: CreateProductInputs;
};

export type MutationCreateProductMediaArgs = {
  data: CreateProductMediaInputs;
  productId: Scalars['String']['input'];
};

export type MutationCreateProductPersonaArgs = {
  data: CreateProductPersonaInputs;
  productId: Scalars['String']['input'];
};

export type MutationCreateSupportArgs = {
  data?: InputMaybe<CreateSupportInputs>;
};

export type MutationCreateTestArgs = {
  data: CreateTestInputs;
  productId: Scalars['String']['input'];
};

export type MutationCreateTestGroupArgs = {
  data: CreateTestGroupInputs;
};

export type MutationCreateTestGroupMemberArgs = {
  data?: InputMaybe<CreateTestGroupMemberInputs>;
};

export type MutationCreateTestTaskArgs = {
  data: CreateTestTaskInputs;
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type MutationCreateWorkspaceTesterArgs = {
  data?: InputMaybe<CreateWorkspaceTesterInputs>;
};

export type MutationDeleteFlowArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationDeleteFlowMediaArgs = {
  data: DeleteFlowMediaInputs;
  productId: Scalars['String']['input'];
};

export type MutationDeleteFlowMediaLinkArgs = {
  flowMediaId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationDeleteProductArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteProductMediaArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationDeleteProductPersonaArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationDeleteTestArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationDeleteTestGroupArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteTestGroupMemberArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteTestTaskArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type MutationFinishTestArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationGetMediaSystemGeneratedHeatMapArgs = {
  mediaId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationPauseTestArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationResendTesterInvitationArgs = {
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  testerId: Scalars['String']['input'];
};

export type MutationStartTestArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationStartTesterTestArgs = {
  data: StartTestInputs;
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type MutationStopTestArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type MutationSubmitSwipeTestResultArgs = {
  data: Array<InputMaybe<SwipeDataInputs>>;
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type MutationSubmitTapTestResultArgs = {
  data: Array<InputMaybe<TapDataInputs>>;
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type MutationSubmitTestMediaTraceArgs = {
  data?: InputMaybe<SubmitTestMediaTraceInputs>;
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type MutationSubmitTestVideoRecordingArgs = {
  data: SubmitTestVideoRecordingInputs;
  id: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type MutationTesterUserFetchOrCreateArgs = {
  data?: InputMaybe<TesterUserFetchOrCreateInputs>;
};

export type MutationTesterUserRegisterArgs = {
  code: Scalars['String']['input'];
  data: TesterUserRegisterInputs;
  id: Scalars['String']['input'];
};

export type MutationTesterUserUpdateProfileArgs = {
  newData: TesterUserUpdateProfileInputs;
};

export type MutationUpdateFlowArgs = {
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateFlowInputs>;
  productId: Scalars['String']['input'];
};

export type MutationUpdateFlowMediaArgs = {
  id: Scalars['String']['input'];
  newData: UpdateFlowMediaInputs;
  productId: Scalars['String']['input'];
};

export type MutationUpdateFlowMediaLinkArgs = {
  flowMediaId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateFlowMediaLinkInputs>;
  productId: Scalars['String']['input'];
};

export type MutationUpdateFlowMediasArgs = {
  newData: Array<InputMaybe<UpdateFlowMediasInputs>>;
  productId: Scalars['String']['input'];
};

export type MutationUpdateProductArgs = {
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateProductInputs>;
};

export type MutationUpdateProductMediaArgs = {
  id: Scalars['String']['input'];
  newData: UpdateProductMediaInputs;
  productId: Scalars['String']['input'];
};

export type MutationUpdateProductPersonaArgs = {
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateProductPersonaInputs>;
  productId: Scalars['String']['input'];
};

export type MutationUpdateProfileArgs = {
  newData?: InputMaybe<UpdateProfileInputs>;
};

export type MutationUpdateTestArgs = {
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateTestInputs>;
  productId: Scalars['String']['input'];
};

export type MutationUpdateTestGroupArgs = {
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateTestGroupInputs>;
};

export type MutationUpdateTestTaskArgs = {
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateTestTaskInputs>;
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type MutationUpdateWorkspaceArgs = {
  newData?: InputMaybe<UpdateWorkspaceInputs>;
};

export type NumberFilterOptions = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
}

export type Payment = {
  createdAt?: Maybe<Scalars['String']['output']>;
  finalPrice?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserPaymentStatus>;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
};

export type PaymentsOutputList = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Payment>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PluralCategoryOutput = {
  data?: Maybe<CategoryListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralCountryOutput = {
  data?: Maybe<Array<Maybe<Country>>>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralFlowMediaOutput = {
  data?: Maybe<FlowMediaListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralFlowOutput = {
  data?: Maybe<FlowListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralGetPaymentOutput = {
  data?: Maybe<PaymentsOutputList>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralProductMediaOutput = {
  data?: Maybe<ProductMediaListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralProductOutput = {
  data?: Maybe<ProductListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralProductPersonaOutput = {
  data?: Maybe<ProductPersonaListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralScreenTypeOutput = {
  data?: Maybe<ScreenTypeListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralSubscriptionPlanOutput = {
  data?: Maybe<SubscriptionPlanListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralTestGroupMemberOutput = {
  data?: Maybe<TestGroupMemberListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralTestGroupOutput = {
  data?: Maybe<TestGroupListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralTestIssuesOutput = {
  data?: Maybe<TestIssuesOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralTestIssuesSummaryOutput = {
  data?: Maybe<Array<Maybe<TestIssuesSummary>>>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralTestOutput = {
  data?: Maybe<TestListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralTestTaskOutput = {
  data?: Maybe<TestTaskListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PluralTesterTestOutput = {
  data?: Maybe<TesterTestListOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type PresignedUrl = {
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  validFor?: Maybe<Scalars['Int']['output']>;
};

export type Product = {
  actionHistory?: Maybe<Array<Maybe<ProductActionHistory>>>;
  category?: Maybe<Category>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorUser?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  iconPath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  osType?: Maybe<ProductOsType>;
  status?: Maybe<ProductStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
};

export type ProductActionHistory = {
  actionType?: Maybe<ProductActionHistoryActionType>;
  createdAt?: Maybe<Scalars['String']['output']>;
  issuedByUser?: Maybe<User>;
  log?: Maybe<Scalars['String']['output']>;
};

export enum ProductActionHistoryActionType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE',
}

export type ProductListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Product>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductMedia = {
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ImageSource>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ScreenType>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ProductMediaListFilters = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductMediaListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<ProductMedia>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ProductOsType {
  Android = 'ANDROID',
  Crossplatform = 'CROSSPLATFORM',
  Ios = 'IOS',
}

export type ProductPersona = {
  behavior?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  fromAge?: Maybe<Scalars['Int']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  targetGender?: Maybe<TargetGender>;
  toAge?: Maybe<Scalars['Int']['output']>;
};

export type ProductPersonaListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<ProductPersona>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type Query = {
  adminLogin?: Maybe<UserLoginOutput>;
  adminRequestLogin?: Maybe<RequestLoginOutput>;
  authenticate?: Maybe<LoginOutput>;
  checkout?: Maybe<CheckoutOutput>;
  generateProductPersona?: Maybe<SingularProductPersonaOutput>;
  generateTestTaskByAi?: Maybe<GenerateTaskByAiOutput>;
  getApplicationVersion?: Maybe<GetApplicationVersionOutput>;
  getCategories?: Maybe<PluralCategoryOutput>;
  getCountries?: Maybe<PluralCountryOutput>;
  getFlow?: Maybe<SingularFlowOutput>;
  getFlowMedia?: Maybe<SingularFlowMediaOutput>;
  getFlowMedias?: Maybe<PluralFlowMediaOutput>;
  getFlows?: Maybe<PluralFlowOutput>;
  getInvoice?: Maybe<GetInvoiceOutput>;
  getMe?: Maybe<SingularTesterUserOutput>;
  getPayment?: Maybe<GetPaymentOutput>;
  getPayments?: Maybe<PluralGetPaymentOutput>;
  getProduct?: Maybe<SingularProductOutput>;
  getProductIncompleteMedias?: Maybe<PluralProductMediaOutput>;
  getProductMedia?: Maybe<SingularProductMediaOutput>;
  getProductMedias?: Maybe<PluralProductMediaOutput>;
  getProductPersona?: Maybe<SingularProductPersonaOutput>;
  getProductPersonas?: Maybe<PluralProductPersonaOutput>;
  getProducts?: Maybe<PluralProductOutput>;
  getScreenTypes?: Maybe<PluralScreenTypeOutput>;
  getSid?: Maybe<GetDuidOutput>;
  getStudyFullTapReport?: Maybe<GetTesterTestFullTapReportOutput>;
  getStudyTaskSuccessRateReport?: Maybe<GetStudyTaskSuccessRateReportOutput>;
  getSubscriptionPlans?: Maybe<PluralSubscriptionPlanOutput>;
  getSupport?: Maybe<SingularSupportOutput>;
  getSupports?: Maybe<GetSupportOutput>;
  getTapsReport?: Maybe<TapReportResultOutput>;
  getTest?: Maybe<SingularTestOutput>;
  getTestGroup?: Maybe<SingularTestGroupOutput>;
  getTestGroupMembers?: Maybe<PluralTestGroupMemberOutput>;
  getTestGroups?: Maybe<PluralTestGroupOutput>;
  getTestIssue?: Maybe<SingularTestIssuesOutput>;
  getTestIssues?: Maybe<PluralTestIssuesOutput>;
  getTestIssuesSummary?: Maybe<PluralTestIssuesSummaryOutput>;
  getTestSessionReport?: Maybe<GetTestSessionReportOutput>;
  getTestTask?: Maybe<SingularTestTaskOutput>;
  getTestTasks?: Maybe<PluralTestTaskOutput>;
  getTester?: Maybe<SingularTesterUserOutput>;
  getTesterReport?: Maybe<GetTesterReportOutput>;
  getTesterTest?: Maybe<SingularTesterTestOutput>;
  getTesterTestFullSwipeReport?: Maybe<GetTesterTestFullSwipeReportOutput>;
  getTesterTestQuickReport?: Maybe<GetTesterTestReportOutput>;
  getTesterTestReportInfo?: Maybe<GetTesterTestReportInfoOutput>;
  getTesterTests?: Maybe<PluralTesterTestOutput>;
  getTests?: Maybe<PluralTestOutput>;
  getUploadPresignedURL?: Maybe<GetPresignedUrlOutput>;
  getUserInvitations?: Maybe<GetUserInvitationsOutput>;
  getUsers?: Maybe<GetUsersOutput>;
  getVideoEmotionsReport?: Maybe<GetVideoEmotionsReportOutput>;
  getWorkspaceStatistics?: Maybe<GetWorkspaceStatisticsOutput>;
  register?: Maybe<LoginOutput>;
  testerUserAuthentication?: Maybe<TesterLoginOutput>;
  testerUserLogin?: Maybe<TesterLoginOutput>;
  testerUserRequestLogin?: Maybe<RequestLoginOutput>;
  testerUserValidateInvitation?: Maybe<ValidateInvitationOutput>;
  userLogin?: Maybe<UserLoginOutput>;
  userRequestLogin?: Maybe<RequestLoginOutput>;
  verifyTestByPublicLink?: Maybe<VerifyTestByPublicLinkOutput>;
};

export type QueryAdminLoginArgs = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type QueryAdminRequestLoginArgs = {
  email: Scalars['String']['input'];
};

export type QueryAuthenticateArgs = {
  data: UserLoginInputs;
};

export type QueryCheckoutArgs = {
  subscriptionPlanId: Scalars['String']['input'];
};

export type QueryGenerateProductPersonaArgs = {
  categoryId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type QueryGenerateTestTaskByAiArgs = {
  flowId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetCategoriesArgs = {
  filters?: InputMaybe<CategoryListFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetFlowArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type QueryGetFlowMediaArgs = {
  flowId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type QueryGetFlowMediasArgs = {
  filters?: InputMaybe<GetFlowMediaFilters>;
  flowId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
};

export type QueryGetFlowsArgs = {
  filters?: InputMaybe<GetFlowsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
};

export type QueryGetInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};

export type QueryGetPaymentArgs = {
  paymentId: Scalars['String']['input'];
};

export type QueryGetPaymentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetProductArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetProductIncompleteMediasArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
};

export type QueryGetProductMediaArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type QueryGetProductMediasArgs = {
  filters?: InputMaybe<ProductMediaListFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
};

export type QueryGetProductPersonaArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type QueryGetProductPersonasArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
};

export type QueryGetProductsArgs = {
  filters?: InputMaybe<GetProductsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetScreenTypesArgs = {
  filters?: InputMaybe<ScreenTypeFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetStudyFullTapReportArgs = {
  mediaId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  testerId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetStudyTaskSuccessRateReportArgs = {
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetSubscriptionPlansArgs = {
  filters?: InputMaybe<GetSubscriptionPlanFilters>;
};

export type QueryGetSupportArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetSupportsArgs = {
  filters?: InputMaybe<GetSupportsFilters>;
};

export type QueryGetTapsReportArgs = {
  mediaId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
  testId: Scalars['String']['input'];
  testerId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTestArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type QueryGetTestGroupArgs = {
  id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetTestGroupMembersArgs = {
  filters: GetTestGroupMembersFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetTestGroupsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetTestIssueArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetTestIssuesArgs = {
  filters?: InputMaybe<GetTestIssuesFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetTestIssuesSummaryArgs = {
  filters?: InputMaybe<GetTestIssuesSummaryFilters>;
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetTestSessionReportArgs = {
  filters?: InputMaybe<GetTestSessionReportInputs>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
};

export type QueryGetTestTaskArgs = {
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetTestTasksArgs = {
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetTesterArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetTesterReportArgs = {
  productId: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
  testId: Scalars['String']['input'];
};

export type QueryGetTesterTestArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetTesterTestFullSwipeReportArgs = {
  mediaId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  testerId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTesterTestQuickReportArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetTesterTestReportInfoArgs = {
  productId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryGetTesterTestsArgs = {
  filters: GetTesterTestsFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetTestsArgs = {
  filters?: InputMaybe<GetTestsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
};

export type QueryGetUploadPresignedUrlArgs = {
  data: GetUploadPresignedUrlInputs;
  type?: InputMaybe<FileUploadType>;
};

export type QueryGetUserInvitationsArgs = {
  filters?: InputMaybe<GetUserInvitationsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetUsersArgs = {
  filters?: InputMaybe<GetUserFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetVideoEmotionsReportArgs = {
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
};

export type QueryRegisterArgs = {
  data: UserRegisterInputs;
};

export type QueryTesterUserAuthenticationArgs = {
  data: TesterUserLoginInputs;
};

export type QueryTesterUserLoginArgs = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type QueryTesterUserRequestLoginArgs = {
  email: Scalars['String']['input'];
};

export type QueryTesterUserValidateInvitationArgs = {
  code: Scalars['String']['input'];
};

export type QueryUserLoginArgs = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type QueryUserRequestLoginArgs = {
  email: Scalars['String']['input'];
};

export type QueryVerifyTestByPublicLinkArgs = {
  code: Scalars['String']['input'];
};

export type RequestLoginOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type ResendTesterInvitationOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type ScreenType = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ScreenTypeFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ScreenTypeListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<ScreenType>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SingularCategoryOutput = {
  data?: Maybe<Category>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularFlowMediaLinkOutput = {
  data?: Maybe<FlowMediaLink>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularFlowMediaOutput = {
  data?: Maybe<FlowMedia>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularFlowOutput = {
  data?: Maybe<Flow>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularProductMediaOutput = {
  data?: Maybe<ProductMedia>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularProductOutput = {
  data?: Maybe<Product>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularProductPersonaOutput = {
  data?: Maybe<ProductPersona>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularScreenTypeOutput = {
  data?: Maybe<Product>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularSubscriptionPlanOutput = {
  data?: Maybe<SubscriptionPlan>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularSupportOutput = {
  data?: Maybe<Support>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularTestGroupMemberOutput = {
  data?: Maybe<TestGroupMember>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularTestGroupOutput = {
  data?: Maybe<TestGroup>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularTestIssuesOutput = {
  data?: Maybe<TesterIssue>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularTestOutput = {
  data?: Maybe<Test>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularTestTaskOutput = {
  data?: Maybe<Task>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularTestUserOutput = {
  data?: Maybe<TesterUser>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularTesterTestOutput = {
  data?: Maybe<TesterTest>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularTesterUserOutput = {
  data?: Maybe<TesterUser>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SingularWorkspaceOutput = {
  data?: Maybe<Workspace>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type StartTestInputs = {
  deviceType: DeviceType;
  osVersion: Scalars['String']['input'];
  screenHeight: Scalars['Int']['input'];
  screenWidth: Scalars['Int']['input'];
};

export type StringFilterOptions = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitResultDataOutput = {
  ack?: Maybe<Scalars['Boolean']['output']>;
  recordCount?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type SubmitResultOutput = {
  data?: Maybe<SubmitResultDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export enum SubmitResultPartStatus {
  Finished = 'FINISHED',
  OnGoing = 'ON_GOING',
}

export type SubmitTestMediaTraceInputs = {
  inTestTime: Scalars['Int']['input'];
  mediaId: Scalars['String']['input'];
  timestamp: Scalars['String']['input'];
};

export type SubmitTestVideoRecordingInputs = {
  videoPath: Scalars['String']['input'];
};

export type SubmitVideoResultOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type Subscription = {
  watchImport?: Maybe<WatchImportOutput>;
};

export type SubscriptionWatchImportArgs = {
  token: Scalars['String']['input'];
};

export type SubscriptionPlan = {
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<Maybe<SubscriptionPlanFeature>>>;
  flowLimit?: Maybe<Scalars['Int']['output']>;
  iconPath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productLimit?: Maybe<Scalars['Int']['output']>;
  responsePerStudy?: Maybe<Scalars['Int']['output']>;
  screenLimit?: Maybe<Scalars['Int']['output']>;
  teamMemberLimit?: Maybe<Scalars['Int']['output']>;
  testLimit?: Maybe<Scalars['Int']['output']>;
  testerLimit?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<SubscriptionPlanType>;
};

export type SubscriptionPlanFeature = {
  description?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPlanListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<SubscriptionPlan>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum SubscriptionPlanType {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
}

export type Support = {
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SupportType>;
  user?: Maybe<User>;
};

export type SupportListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Support>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum SupportType {
  BugReport = 'BUG_REPORT',
  Feedback = 'FEEDBACK',
  Support = 'SUPPORT',
}

export type SwipeDataInputs = {
  direction: SwipeDirection;
  endX: Scalars['Float']['input'];
  endY: Scalars['Float']['input'];
  inTestTime: Scalars['Int']['input'];
  mediaId: Scalars['String']['input'];
  startX: Scalars['Float']['input'];
  startY: Scalars['Float']['input'];
  timestamp: Scalars['String']['input'];
};

export enum SwipeDirection {
  DownToUp = 'DOWN_TO_UP',
  LeftToRight = 'LEFT_TO_RIGHT',
  RightToLeft = 'RIGHT_TO_LEFT',
  UpToDown = 'UP_TO_DOWN',
}

export type TapDataInputs = {
  inTestTime: Scalars['Int']['input'];
  mediaId: Scalars['String']['input'];
  tapType: UserTapType;
  timestamp: Scalars['String']['input'];
  type: TapType;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type TapReportOutput = {
  HIT?: Maybe<TapResultOutput>;
  MISS?: Maybe<TapResultOutput>;
  TARGET?: Maybe<TapResultOutput>;
  averageDuration?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TapReportResultOutput = {
  data?: Maybe<TapReportOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type TapResultOutput = {
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export enum TapType {
  DoubleTap = 'DOUBLE_TAP',
  LongTap = 'LONG_TAP',
  Tap = 'TAP',
}

export enum TargetGender {
  Both = 'BOTH',
  Female = 'FEMALE',
  Male = 'MALE',
}

export type Task = {
  description?: Maybe<Scalars['String']['output']>;
  flow?: Maybe<Flow>;
  id?: Maybe<Scalars['String']['output']>;
  targetMedia?: Maybe<ProductMedia>;
};

export type Test = {
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorUser?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<TestGroup>>>;
  id?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  progressStatus?: Maybe<TestProgressStatus>;
  publicLink?: Maybe<TestPublicLink>;
  scenario?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TestStatus>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  type?: Maybe<TestType>;
};

export type TestChangeStatusOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type TestGroup = {
  creatorUser?: Maybe<User>;
  id?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<Maybe<TesterUser>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TestGroupListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<TestGroup>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TestGroupMember = {
  id?: Maybe<Scalars['String']['output']>;
  testerUser?: Maybe<TesterUser>;
};

export type TestGroupMemberListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<TestGroupMember>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TestIssuesOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<TesterIssue>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TestIssuesSummary = {
  issueType?: Maybe<IssueType>;
  summery?: Maybe<Scalars['String']['output']>;
};

export type TestIssuesSummaryOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<TestIssuesSummary>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TestListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Test>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum TestProgressStatus {
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  Ready = 'READY',
}

export type TestPublicLink = {
  code?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TestPublicLinkStatus>;
  test?: Maybe<Test>;
};

export enum TestPublicLinkStatus {
  Accepting = 'ACCEPTING',
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
}

export enum TestStatus {
  Archived = 'ARCHIVED',
  Enabled = 'ENABLED',
}

export type TestTaskListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Test>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TestType = {
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TesterIssue = {
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issueCategory?: Maybe<IssueCategory>;
  issueDescription?: Maybe<Scalars['String']['output']>;
  issuePriority?: Maybe<IssuePriority>;
  issueType?: Maybe<IssueType>;
  task?: Maybe<Task>;
  test?: Maybe<Test>;
  tester?: Maybe<TesterUser>;
};

export type TesterLoginDataOutput = {
  at?: Maybe<Scalars['String']['output']>;
  irc?: Maybe<Scalars['Boolean']['output']>;
  rt?: Maybe<Scalars['String']['output']>;
};

export type TesterLoginOutput = {
  data?: Maybe<TesterLoginDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type TesterTest = {
  actionStatus?: Maybe<TesterUserTestActionStatus>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  task?: Maybe<Task>;
  test?: Maybe<Test>;
  testerUser?: Maybe<TesterUser>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type TesterTestListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<TesterTest>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TesterUser = {
  avatar?: Maybe<Scalars['String']['output']>;
  birthYear?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  defaultHand?: Maybe<DefaultHand>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  handSize?: Maybe<HandSize>;
  id?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  registrationStatus?: Maybe<TesterUserRegistrationStatus>;
  username?: Maybe<Scalars['String']['output']>;
};

export type TesterUserFetchOrCreateInputs = {
  email: Scalars['String']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
};

export type TesterUserLoginInputs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type TesterUserLogoutOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type TesterUserRegisterInputs = {
  avatar: Scalars['String']['input'];
  birthYear: Scalars['String']['input'];
  defaultHand?: InputMaybe<DefaultHand>;
  displayName: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  handSize?: InputMaybe<HandSize>;
  password: Scalars['String']['input'];
};

export enum TesterUserRegistrationStatus {
  Member = 'MEMBER',
  Pending = 'PENDING',
}

export enum TesterUserTestActionStatus {
  Assigned = 'ASSIGNED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
}

export type TesterUserUpdateProfileInputs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthYear: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  defaultHand: DefaultHand;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  gender: Gender;
  handSize: HandSize;
};

export type UpdateFlowInputs = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FlowStatus>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFlowMediaInputs = {
  isFlowStartPage?: InputMaybe<Scalars['Boolean']['input']>;
  isTarget?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFlowMediaLinkInputs = {
  endX?: InputMaybe<Scalars['Float']['input']>;
  endY?: InputMaybe<Scalars['Float']['input']>;
  isFlowTap?: InputMaybe<Scalars['Boolean']['input']>;
  linkToMediaId?: InputMaybe<Scalars['String']['input']>;
  startX?: InputMaybe<Scalars['Float']['input']>;
  startY?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFlowMediasInputs = {
  flowId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isFlowStartPage?: InputMaybe<Scalars['Boolean']['input']>;
  isTarget?: InputMaybe<Scalars['Boolean']['input']>;
  mediaId: Scalars['String']['input'];
};

export type UpdateFlowMediasOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type UpdateProductInputs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconPath?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  osType?: InputMaybe<ProductOsType>;
};

export type UpdateProductMediaInputs = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductPersonaInputs = {
  behavior?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  fromAge?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetGender?: InputMaybe<TargetGender>;
  toAge?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProfileInputs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTestGroupInputs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTestInputs = {
  description?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scenario?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TestStatus>;
};

export type UpdateTestTaskInputs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flowId?: InputMaybe<Scalars['String']['input']>;
  targetMediaId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceInputs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum UploadType {
  ProductImage = 'PRODUCT_IMAGE',
  ProductScreen = 'PRODUCT_SCREEN',
  Profile = 'PROFILE',
}

export type User = {
  avatar?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserInvitation = {
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserInvitationListStatus>;
};

export type UserInvitationListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<UserInvitation>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum UserInvitationListStatus {
  Approved = 'APPROVED',
  Unapproved = 'UNAPPROVED',
}

export type UserListOutput = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<User>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserLoginDataOutput = {
  at?: Maybe<Scalars['String']['output']>;
  irc?: Maybe<Scalars['Boolean']['output']>;
  rt?: Maybe<Scalars['String']['output']>;
};

export type UserLoginInputs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserLoginOutput = {
  data?: Maybe<UserLoginDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export enum UserPaymentStatus {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Paid = 'PAID',
}

export type UserRegisterInputs = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum UserStatus {
  Deleted = 'DELETED',
  Enabled = 'ENABLED',
  Suspended = 'SUSPENDED',
}

export enum UserTapType {
  Hit = 'HIT',
  Miss = 'MISS',
  Target = 'TARGET',
}

export type ValidateInvitationOutput = {
  data?: Maybe<ValidateInvitationResult>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type ValidateInvitationResult = {
  isValid?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type VerifyTestByPublicLinkOutput = {
  data?: Maybe<TestPublicLink>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type WatchImportOutput = {
  status?: Maybe<WatchImportStatus>;
};

export enum WatchImportStatus {
  Done = 'DONE',
  Expired = 'EXPIRED',
  Waiting = 'WAITING',
}

export type Workspace = {
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceStatisticsOutput = {
  flow?: Maybe<ItemStatisticsType>;
  product?: Maybe<ItemStatisticsType>;
  study?: Maybe<ItemStatisticsType>;
};

export type RequestLoginQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type RequestLoginQuery = {
  userRequestLogin?: { statusCode?: number | null; message?: string | null } | null;
};

export type UserLoginQueryVariables = Exact<{
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
}>;

export type UserLoginQuery = {
  userLogin?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { at?: string | null; rt?: string | null } | null;
  } | null;
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshTokenMutation = {
  refreshToken?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { at?: string | null; rt?: string | null } | null;
  } | null;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = {
  logout?: { statusCode?: number | null; message?: string | null } | null;
};

export type CategoryFragmentFragment = { id?: string | null; name?: string | null };

export type GetCategoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<CategoryListFilters>;
}>;

export type GetCategoriesQuery = {
  getCategories?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{ id?: string | null; name?: string | null } | null> | null;
    } | null;
  } | null;
};

export type FlowMediaLinkFragmentFragment = {
  id?: string | null;
  startX?: number | null;
  startY?: number | null;
  endX?: number | null;
  endY?: number | null;
  isFlowTap?: boolean | null;
  linkToMedia?: {
    id?: string | null;
    imagePath?: string | null;
    version?: string | null;
    title?: string | null;
    description?: string | null;
    source?: ImageSource | null;
    type?: { id?: string | null; name?: string | null } | null;
  } | null;
};

export type CreateFlowMediaLinkMutationVariables = Exact<{
  data: CreateFlowMediaLinkInputs;
  flowMediaId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type CreateFlowMediaLinkMutation = {
  createFlowMediaLink?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      startX?: number | null;
      startY?: number | null;
      endX?: number | null;
      endY?: number | null;
      isFlowTap?: boolean | null;
      linkToMedia?: {
        id?: string | null;
        imagePath?: string | null;
        version?: string | null;
        title?: string | null;
        description?: string | null;
        source?: ImageSource | null;
        type?: { id?: string | null; name?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateFlowMediaLinkMutationVariables = Exact<{
  id: Scalars['String']['input'];
  flowMediaId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  newData?: InputMaybe<UpdateFlowMediaLinkInputs>;
}>;

export type UpdateFlowMediaLinkMutation = {
  updateFlowMediaLink?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      startX?: number | null;
      startY?: number | null;
      endX?: number | null;
      endY?: number | null;
      isFlowTap?: boolean | null;
      linkToMedia?: {
        id?: string | null;
        imagePath?: string | null;
        version?: string | null;
        title?: string | null;
        description?: string | null;
        source?: ImageSource | null;
        type?: { id?: string | null; name?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteFlowMediaLinkMutationVariables = Exact<{
  id: Scalars['String']['input'];
  flowMediaId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type DeleteFlowMediaLinkMutation = {
  deleteFlowMediaLink?: { statusCode?: number | null; message?: string | null } | null;
};

export type FlowMediaWithoutLinksFragmentFragment = {
  id?: string | null;
  isFlowStartPage?: boolean | null;
  isTarget?: boolean | null;
  media?: {
    id?: string | null;
    imagePath?: string | null;
    version?: string | null;
    title?: string | null;
    description?: string | null;
    source?: ImageSource | null;
    type?: { id?: string | null; name?: string | null } | null;
  } | null;
};

export type FlowMediaFragmentFragment = {
  id?: string | null;
  isFlowStartPage?: boolean | null;
  isTarget?: boolean | null;
  links?: Array<{
    id?: string | null;
    startX?: number | null;
    startY?: number | null;
    endX?: number | null;
    endY?: number | null;
    isFlowTap?: boolean | null;
    linkToMedia?: {
      id?: string | null;
      imagePath?: string | null;
      version?: string | null;
      title?: string | null;
      description?: string | null;
      source?: ImageSource | null;
      type?: { id?: string | null; name?: string | null } | null;
    } | null;
  } | null> | null;
  media?: {
    id?: string | null;
    imagePath?: string | null;
    version?: string | null;
    title?: string | null;
    description?: string | null;
    source?: ImageSource | null;
    type?: { id?: string | null; name?: string | null } | null;
  } | null;
};

export type GetFlowMediasQueryVariables = Exact<{
  flowId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  filters?: InputMaybe<GetFlowMediaFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFlowMediasQuery = {
  getFlowMedias?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        isFlowStartPage?: boolean | null;
        isTarget?: boolean | null;
        media?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetFlowMediaQueryVariables = Exact<{
  id: Scalars['String']['input'];
  flowId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetFlowMediaQuery = {
  getFlowMedia?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      isFlowStartPage?: boolean | null;
      isTarget?: boolean | null;
      links?: Array<{
        id?: string | null;
        startX?: number | null;
        startY?: number | null;
        endX?: number | null;
        endY?: number | null;
        isFlowTap?: boolean | null;
        linkToMedia?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
      media?: {
        id?: string | null;
        imagePath?: string | null;
        version?: string | null;
        title?: string | null;
        description?: string | null;
        source?: ImageSource | null;
        type?: { id?: string | null; name?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type CreateFlowMediaMutationVariables = Exact<{
  data: CreateFlowMediaInputs;
  productId: Scalars['String']['input'];
}>;

export type CreateFlowMediaMutation = {
  createFlowMedia?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      isFlowStartPage?: boolean | null;
      isTarget?: boolean | null;
      links?: Array<{
        id?: string | null;
        startX?: number | null;
        startY?: number | null;
        endX?: number | null;
        endY?: number | null;
        isFlowTap?: boolean | null;
        linkToMedia?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
      media?: {
        id?: string | null;
        imagePath?: string | null;
        version?: string | null;
        title?: string | null;
        description?: string | null;
        source?: ImageSource | null;
        type?: { id?: string | null; name?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type CreateFlowMediasMutationVariables = Exact<{
  data: Array<InputMaybe<CreateFlowMediaInputs>> | InputMaybe<CreateFlowMediaInputs>;
  productId: Scalars['String']['input'];
}>;

export type CreateFlowMediasMutation = {
  createFlowMedias?: { statusCode?: number | null; message?: string | null } | null;
};

export type UpdateFlowMediasMutationVariables = Exact<{
  newData: Array<InputMaybe<UpdateFlowMediasInputs>> | InputMaybe<UpdateFlowMediasInputs>;
  productId: Scalars['String']['input'];
}>;

export type UpdateFlowMediasMutation = {
  updateFlowMedias?: { statusCode?: number | null; message?: string | null } | null;
};

export type DeleteFlowMediaMutationVariables = Exact<{
  data: DeleteFlowMediaInputs;
  productId: Scalars['String']['input'];
}>;

export type DeleteFlowMediaMutation = {
  deleteFlowMedia?: { statusCode?: number | null; message?: string | null } | null;
};

export type FlowFragmentFragment = {
  id?: string | null;
  name?: string | null;
  version?: string | null;
  status?: FlowStatus | null;
  isLocked?: boolean | null;
  medias?: Array<{
    id?: string | null;
    isFlowStartPage?: boolean | null;
    isTarget?: boolean | null;
    media?: {
      id?: string | null;
      imagePath?: string | null;
      version?: string | null;
      title?: string | null;
      description?: string | null;
      source?: ImageSource | null;
      type?: { id?: string | null; name?: string | null } | null;
    } | null;
  } | null> | null;
};

export type GetFlowsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  filters?: InputMaybe<GetFlowsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFlowsQuery = {
  getFlows?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        name?: string | null;
        version?: string | null;
        status?: FlowStatus | null;
        isLocked?: boolean | null;
        medias?: Array<{
          id?: string | null;
          isFlowStartPage?: boolean | null;
          isTarget?: boolean | null;
          media?: {
            id?: string | null;
            imagePath?: string | null;
            version?: string | null;
            title?: string | null;
            description?: string | null;
            source?: ImageSource | null;
            type?: { id?: string | null; name?: string | null } | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetFlowQueryVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetFlowQuery = {
  getFlow?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      version?: string | null;
      status?: FlowStatus | null;
      isLocked?: boolean | null;
      medias?: Array<{
        id?: string | null;
        isFlowStartPage?: boolean | null;
        isTarget?: boolean | null;
        media?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CreateFlowMutationVariables = Exact<{
  data: CreateFlowInputs;
  productId: Scalars['String']['input'];
}>;

export type CreateFlowMutation = {
  createFlow?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      version?: string | null;
      status?: FlowStatus | null;
      isLocked?: boolean | null;
      medias?: Array<{
        id?: string | null;
        isFlowStartPage?: boolean | null;
        isTarget?: boolean | null;
        media?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UpdateFlowMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  newData?: InputMaybe<UpdateFlowInputs>;
}>;

export type UpdateFlowMutation = {
  updateFlow?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      version?: string | null;
      status?: FlowStatus | null;
      isLocked?: boolean | null;
      medias?: Array<{
        id?: string | null;
        isFlowStartPage?: boolean | null;
        isTarget?: boolean | null;
        media?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type DeleteFlowMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type DeleteFlowMutation = {
  deleteFlow?: { statusCode?: number | null; message?: string | null } | null;
};

export type FigmaImportTokenDataFragmentFragment = {
  token?: string | null;
  validFor?: number | null;
};

export type CreateFigmaImportTokenMutationVariables = Exact<{
  productId: Scalars['String']['input'];
}>;

export type CreateFigmaImportTokenMutation = {
  createFigmaImportToken?: {
    message?: string | null;
    statusCode?: number | null;
    data?: { token?: string | null; validFor?: number | null } | null;
  } | null;
};

export type WatchImportSubscriptionVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type WatchImportSubscription = {
  watchImport?: { status?: WatchImportStatus | null } | null;
};

export type PureTesterIssueFragmentFragment = {
  id?: string | null;
  issuePriority?: IssuePriority | null;
  issueType?: IssueType | null;
  issueCategory?: IssueCategory | null;
  issueDescription?: string | null;
  createdAt?: string | null;
};

export type TesterIssueFragmentFragment = {
  id?: string | null;
  issuePriority?: IssuePriority | null;
  issueType?: IssueType | null;
  issueCategory?: IssueCategory | null;
  issueDescription?: string | null;
  createdAt?: string | null;
  test?: {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    status?: TestStatus | null;
    goal?: string | null;
    scenario?: string | null;
    progressStatus?: TestProgressStatus | null;
    createdAt?: string | null;
  } | null;
  tester?: {
    id?: string | null;
    fullName?: string | null;
    email?: string | null;
    username?: string | null;
    mobile?: string | null;
    gender?: Gender | null;
    registrationStatus?: TesterUserRegistrationStatus | null;
    birthYear?: string | null;
    defaultHand?: DefaultHand | null;
    handSize?: HandSize | null;
    avatar?: string | null;
    displayName?: string | null;
    country?: { name?: string | null } | null;
  } | null;
  task?: {
    id?: string | null;
    description?: string | null;
    flow?: {
      id?: string | null;
      name?: string | null;
      version?: string | null;
      status?: FlowStatus | null;
      isLocked?: boolean | null;
      medias?: Array<{
        id?: string | null;
        isFlowStartPage?: boolean | null;
        isTarget?: boolean | null;
        media?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetTestIssuesQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  filters?: InputMaybe<GetTestIssuesFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetTestIssuesQuery = {
  getTestIssues?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        issuePriority?: IssuePriority | null;
        issueType?: IssueType | null;
        issueCategory?: IssueCategory | null;
        issueDescription?: string | null;
        createdAt?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetTestIssueQueryVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
}>;

export type GetTestIssueQuery = {
  getTestIssue?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      issuePriority?: IssuePriority | null;
      issueType?: IssueType | null;
      issueCategory?: IssueCategory | null;
      issueDescription?: string | null;
      createdAt?: string | null;
      test?: {
        id?: string | null;
        name?: string | null;
        description?: string | null;
        status?: TestStatus | null;
        goal?: string | null;
        scenario?: string | null;
        progressStatus?: TestProgressStatus | null;
        createdAt?: string | null;
      } | null;
      tester?: {
        id?: string | null;
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        registrationStatus?: TesterUserRegistrationStatus | null;
        birthYear?: string | null;
        defaultHand?: DefaultHand | null;
        handSize?: HandSize | null;
        avatar?: string | null;
        displayName?: string | null;
        country?: { name?: string | null } | null;
      } | null;
      task?: {
        id?: string | null;
        description?: string | null;
        flow?: {
          id?: string | null;
          name?: string | null;
          version?: string | null;
          status?: FlowStatus | null;
          isLocked?: boolean | null;
          medias?: Array<{
            id?: string | null;
            isFlowStartPage?: boolean | null;
            isTarget?: boolean | null;
            media?: {
              id?: string | null;
              imagePath?: string | null;
              version?: string | null;
              title?: string | null;
              description?: string | null;
              source?: ImageSource | null;
              type?: { id?: string | null; name?: string | null } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetTestIssuesSummaryQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  filters?: InputMaybe<GetTestIssuesSummaryFilters>;
}>;

export type GetTestIssuesSummaryQuery = {
  getTestIssuesSummary?: {
    statusCode?: number | null;
    message?: string | null;
    data?: Array<{ issueType?: IssueType | null; summery?: string | null } | null> | null;
  } | null;
};

export type ScreenTypeFragmentFragment = { id?: string | null; name?: string | null };

export type ProductMediaFragmentFragment = {
  id?: string | null;
  imagePath?: string | null;
  version?: string | null;
  title?: string | null;
  description?: string | null;
  source?: ImageSource | null;
  type?: { id?: string | null; name?: string | null } | null;
};

export type GetProductMediasQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProductMediaListFilters>;
}>;

export type GetProductMediasQuery = {
  getProductMedias?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        imagePath?: string | null;
        version?: string | null;
        title?: string | null;
        description?: string | null;
        source?: ImageSource | null;
        type?: { id?: string | null; name?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetProductIncompleteMediasQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetProductIncompleteMediasQuery = {
  getProductIncompleteMedias?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        imagePath?: string | null;
        version?: string | null;
        title?: string | null;
        description?: string | null;
        source?: ImageSource | null;
        type?: { id?: string | null; name?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetProductMediaQueryVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetProductMediaQuery = {
  getProductMedia?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      imagePath?: string | null;
      version?: string | null;
      title?: string | null;
      description?: string | null;
      source?: ImageSource | null;
      type?: { id?: string | null; name?: string | null } | null;
    } | null;
  } | null;
};

export type CreateProductMediaMutationVariables = Exact<{
  data: CreateProductMediaInputs;
  productId: Scalars['String']['input'];
}>;

export type CreateProductMediaMutation = {
  createProductMedia?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      imagePath?: string | null;
      version?: string | null;
      title?: string | null;
      description?: string | null;
      source?: ImageSource | null;
      type?: { id?: string | null; name?: string | null } | null;
    } | null;
  } | null;
};

export type UpdateProductMediaMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  newData: UpdateProductMediaInputs;
}>;

export type UpdateProductMediaMutation = {
  updateProductMedia?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      imagePath?: string | null;
      version?: string | null;
      title?: string | null;
      description?: string | null;
      source?: ImageSource | null;
      type?: { id?: string | null; name?: string | null } | null;
    } | null;
  } | null;
};

export type DeleteProductMediaMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type DeleteProductMediaMutation = {
  deleteProductMedia?: { statusCode?: number | null; message?: string | null } | null;
};

export type GetScreenTypesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ScreenTypeFilter>;
}>;

export type GetScreenTypesQuery = {
  getScreenTypes?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{ id?: string | null; name?: string | null } | null> | null;
    } | null;
  } | null;
};

export type ProductPersonaFragmentFragment = {
  id?: string | null;
  name?: string | null;
  behavior?: string | null;
  bio?: string | null;
  goal?: string | null;
  fromAge?: number | null;
  toAge?: number | null;
  targetGender?: TargetGender | null;
};

export type GenerateProductPersonaQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GenerateProductPersonaQuery = {
  generateProductPersona?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      behavior?: string | null;
      bio?: string | null;
      goal?: string | null;
      fromAge?: number | null;
      toAge?: number | null;
      targetGender?: TargetGender | null;
    } | null;
  } | null;
};

export type GetProductPersonasQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetProductPersonasQuery = {
  getProductPersonas?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        name?: string | null;
        behavior?: string | null;
        bio?: string | null;
        goal?: string | null;
        fromAge?: number | null;
        toAge?: number | null;
        targetGender?: TargetGender | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetProductPersonaQueryVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetProductPersonaQuery = {
  getProductPersona?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      behavior?: string | null;
      bio?: string | null;
      goal?: string | null;
      fromAge?: number | null;
      toAge?: number | null;
      targetGender?: TargetGender | null;
    } | null;
  } | null;
};

export type CreateProductPersonaMutationVariables = Exact<{
  data: CreateProductPersonaInputs;
  productId: Scalars['String']['input'];
}>;

export type CreateProductPersonaMutation = {
  createProductPersona?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      behavior?: string | null;
      bio?: string | null;
      goal?: string | null;
      fromAge?: number | null;
      toAge?: number | null;
      targetGender?: TargetGender | null;
    } | null;
  } | null;
};

export type UpdateProductPersonaMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  newData?: InputMaybe<UpdateProductPersonaInputs>;
}>;

export type UpdateProductPersonaMutation = {
  updateProductPersona?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      behavior?: string | null;
      bio?: string | null;
      goal?: string | null;
      fromAge?: number | null;
      toAge?: number | null;
      targetGender?: TargetGender | null;
    } | null;
  } | null;
};

export type DeleteProductPersonaMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type DeleteProductPersonaMutation = {
  deleteProductPersona?: { statusCode?: number | null; message?: string | null } | null;
};

export type PureProductFragmentFragment = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  iconPath?: string | null;
  osType?: ProductOsType | null;
  status?: ProductStatus | null;
  createdAt?: string | null;
};

export type ProductActionHistoryFragmentFragment = {
  log?: string | null;
  actionType?: ProductActionHistoryActionType | null;
  createdAt?: string | null;
  issuedByUser?: {
    fullName?: string | null;
    email?: string | null;
    username?: string | null;
    mobile?: string | null;
    gender?: Gender | null;
    status?: UserStatus | null;
    avatar?: string | null;
  } | null;
};

export type ProductFragmentFragment = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  iconPath?: string | null;
  osType?: ProductOsType | null;
  status?: ProductStatus | null;
  createdAt?: string | null;
  category?: { id?: string | null; name?: string | null } | null;
  creatorUser?: {
    fullName?: string | null;
    email?: string | null;
    username?: string | null;
    mobile?: string | null;
    gender?: Gender | null;
    status?: UserStatus | null;
    avatar?: string | null;
  } | null;
  workspace?: { id?: string | null; name?: string | null } | null;
  actionHistory?: Array<{
    log?: string | null;
    actionType?: ProductActionHistoryActionType | null;
    createdAt?: string | null;
    issuedByUser?: {
      fullName?: string | null;
      email?: string | null;
      username?: string | null;
      mobile?: string | null;
      gender?: Gender | null;
      status?: UserStatus | null;
      avatar?: string | null;
    } | null;
  } | null> | null;
};

export type GetProductsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GetProductsFilters>;
}>;

export type GetProductsQuery = {
  getProducts?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        name?: string | null;
        description?: string | null;
        iconPath?: string | null;
        osType?: ProductOsType | null;
        status?: ProductStatus | null;
        createdAt?: string | null;
        category?: { id?: string | null; name?: string | null } | null;
        creatorUser?: {
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          status?: UserStatus | null;
          avatar?: string | null;
        } | null;
        workspace?: { id?: string | null; name?: string | null } | null;
        actionHistory?: Array<{
          log?: string | null;
          actionType?: ProductActionHistoryActionType | null;
          createdAt?: string | null;
          issuedByUser?: {
            fullName?: string | null;
            email?: string | null;
            username?: string | null;
            mobile?: string | null;
            gender?: Gender | null;
            status?: UserStatus | null;
            avatar?: string | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetProductQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetProductQuery = {
  getProduct?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      description?: string | null;
      iconPath?: string | null;
      osType?: ProductOsType | null;
      status?: ProductStatus | null;
      createdAt?: string | null;
      category?: { id?: string | null; name?: string | null } | null;
      creatorUser?: {
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        status?: UserStatus | null;
        avatar?: string | null;
      } | null;
      workspace?: { id?: string | null; name?: string | null } | null;
      actionHistory?: Array<{
        log?: string | null;
        actionType?: ProductActionHistoryActionType | null;
        createdAt?: string | null;
        issuedByUser?: {
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          status?: UserStatus | null;
          avatar?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CreateProductMutationVariables = Exact<{
  data: CreateProductInputs;
}>;

export type CreateProductMutation = {
  createProduct?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      description?: string | null;
      iconPath?: string | null;
      osType?: ProductOsType | null;
      status?: ProductStatus | null;
      createdAt?: string | null;
      category?: { id?: string | null; name?: string | null } | null;
      creatorUser?: {
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        status?: UserStatus | null;
        avatar?: string | null;
      } | null;
      workspace?: { id?: string | null; name?: string | null } | null;
      actionHistory?: Array<{
        log?: string | null;
        actionType?: ProductActionHistoryActionType | null;
        createdAt?: string | null;
        issuedByUser?: {
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          status?: UserStatus | null;
          avatar?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateProductInputs>;
}>;

export type UpdateProductMutation = {
  updateProduct?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      description?: string | null;
      iconPath?: string | null;
      osType?: ProductOsType | null;
      status?: ProductStatus | null;
      createdAt?: string | null;
      category?: { id?: string | null; name?: string | null } | null;
      creatorUser?: {
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        status?: UserStatus | null;
        avatar?: string | null;
      } | null;
      workspace?: { id?: string | null; name?: string | null } | null;
      actionHistory?: Array<{
        log?: string | null;
        actionType?: ProductActionHistoryActionType | null;
        createdAt?: string | null;
        issuedByUser?: {
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          status?: UserStatus | null;
          avatar?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteProductMutation = {
  deleteProduct?: { statusCode?: number | null; message?: string | null } | null;
};

export type GetGenderReportOutputDataFragmentFragment = {
  MALE?: number | null;
  FEMALE?: number | null;
  NON_BINARY?: number | null;
};

export type GetHandHoldPositionReportFullObjectFragmentFragment = {
  CRADLED?: { count?: number | null; percentage?: number | null } | null;
  HOLD_AND_TOUCH?: { count?: number | null; percentage?: number | null } | null;
  ONE_HAND_FIRST_ORDER?: { count?: number | null; percentage?: number | null } | null;
  ONE_HAND_SECOND_ORDER?: { count?: number | null; percentage?: number | null } | null;
  TWO_HANDS_PORTRAIT?: { count?: number | null; percentage?: number | null } | null;
  TWO_HANDS_LANDSCAPE?: { count?: number | null; percentage?: number | null } | null;
};

export type GetDefaultHandReportOutputDataFragmentFragment = {
  LEFT?: number | null;
  RIGHT?: number | null;
};

export type GetDeviceTypeReportOutputDataFragmentFragment = {
  ANDROID?: number | null;
  IPHONE?: number | null;
};

export type GetTesterReportQueryVariables = Exact<{
  testId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetTesterReportQuery = {
  getTesterReport?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      age?: any | null;
      gender?: { MALE?: number | null; FEMALE?: number | null; NON_BINARY?: number | null } | null;
      handHoldPosition?: {
        CRADLED?: { count?: number | null; percentage?: number | null } | null;
        HOLD_AND_TOUCH?: { count?: number | null; percentage?: number | null } | null;
        ONE_HAND_FIRST_ORDER?: { count?: number | null; percentage?: number | null } | null;
        ONE_HAND_SECOND_ORDER?: { count?: number | null; percentage?: number | null } | null;
        TWO_HANDS_PORTRAIT?: { count?: number | null; percentage?: number | null } | null;
        TWO_HANDS_LANDSCAPE?: { count?: number | null; percentage?: number | null } | null;
      } | null;
      defaultHand?: { LEFT?: number | null; RIGHT?: number | null } | null;
      deviceType?: { ANDROID?: number | null; IPHONE?: number | null } | null;
    } | null;
  } | null;
};

export type GetTesterTestQuickReportQueryVariables = Exact<{
  testId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetTesterTestQuickReportQuery = {
  getTesterTestQuickReport?: {
    statusCode?: number | null;
    message?: string | null;
    data?: Array<{
      fullName?: string | null;
      totalDuration?: number | null;
      task?: {
        id?: string | null;
        description?: string | null;
        flow?: {
          id?: string | null;
          name?: string | null;
          version?: string | null;
          status?: FlowStatus | null;
          isLocked?: boolean | null;
          medias?: Array<{
            id?: string | null;
            isFlowStartPage?: boolean | null;
            isTarget?: boolean | null;
            media?: {
              id?: string | null;
              imagePath?: string | null;
              version?: string | null;
              title?: string | null;
              description?: string | null;
              source?: ImageSource | null;
              type?: { id?: string | null; name?: string | null } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetTesterTestReportInfoQueryVariables = Exact<{
  testId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
}>;

export type GetTesterTestReportInfoQuery = {
  getTesterTestReportInfo?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      testers?: Array<{
        id?: string | null;
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        registrationStatus?: TesterUserRegistrationStatus | null;
        birthYear?: string | null;
        defaultHand?: DefaultHand | null;
        handSize?: HandSize | null;
        avatar?: string | null;
        displayName?: string | null;
        country?: { name?: string | null } | null;
      } | null> | null;
      medias?: Array<{
        isFlowStartPage?: boolean | null;
        media?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetStudyFullTapReportQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  mediaId: Scalars['String']['input'];
  testerId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetStudyFullTapReportQuery = {
  getStudyFullTapReport?: {
    statusCode?: number | null;
    message?: string | null;
    data?: Array<{
      x?: number | null;
      y?: number | null;
      order?: number | null;
      type?: TapType | null;
    } | null> | null;
  } | null;
};

export type GetTapsReportQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
  testerId?: InputMaybe<Scalars['String']['input']>;
  mediaId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetTapsReportQuery = {
  getTapsReport?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      total?: number | null;
      averageDuration?: number | null;
      HIT?: { percentage?: number | null; count?: number | null } | null;
      MISS?: { percentage?: number | null; count?: number | null } | null;
      TARGET?: { percentage?: number | null; count?: number | null } | null;
    } | null;
  } | null;
};

export type GetStudyTaskSuccessRateReportQueryVariables = Exact<{
  testId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetStudyTaskSuccessRateReportQuery = {
  getStudyTaskSuccessRateReport?: {
    message?: string | null;
    statusCode?: number | null;
    data?: Array<{
      task?: { id?: string | null; description?: string | null } | null;
      statistics?: {
        successRate?: number | null;
        totalCount?: number | null;
        successCount?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetVideoEmotionsReportQueryVariables = Exact<{
  testId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetVideoEmotionsReportQuery = {
  getVideoEmotionsReport?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      testId?: string | null;
      emotions?: {
        angry?: number | null;
        disgust?: number | null;
        fear?: number | null;
        happy?: number | null;
        sad?: number | null;
        surprise?: number | null;
        neutral?: number | null;
      } | null;
    } | null;
  } | null;
};

export type GetTestSessionReportQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GetTestSessionReportInputs>;
}>;

export type GetTestSessionReportQuery = {
  getTestSessionReport?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        actionStatus?: TesterUserTestActionStatus | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        totalDuration?: number | null;
        test?: {
          id?: string | null;
          name?: string | null;
          description?: string | null;
          status?: TestStatus | null;
          goal?: string | null;
          scenario?: string | null;
          progressStatus?: TestProgressStatus | null;
          createdAt?: string | null;
        } | null;
        task?: {
          id?: string | null;
          description?: string | null;
          flow?: {
            id?: string | null;
            name?: string | null;
            version?: string | null;
            status?: FlowStatus | null;
            isLocked?: boolean | null;
            medias?: Array<{
              id?: string | null;
              isFlowStartPage?: boolean | null;
              isTarget?: boolean | null;
              media?: {
                id?: string | null;
                imagePath?: string | null;
                version?: string | null;
                title?: string | null;
                description?: string | null;
                source?: ImageSource | null;
                type?: { id?: string | null; name?: string | null } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
        testerUser?: {
          id?: string | null;
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          registrationStatus?: TesterUserRegistrationStatus | null;
          birthYear?: string | null;
          defaultHand?: DefaultHand | null;
          handSize?: HandSize | null;
          avatar?: string | null;
          displayName?: string | null;
          country?: { name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type TestTypeFragmentFragment = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
};

export type PureTestFragmentFragment = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  status?: TestStatus | null;
  goal?: string | null;
  scenario?: string | null;
  progressStatus?: TestProgressStatus | null;
  createdAt?: string | null;
};

export type TestFragmentFragment = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  status?: TestStatus | null;
  goal?: string | null;
  scenario?: string | null;
  progressStatus?: TestProgressStatus | null;
  createdAt?: string | null;
  type?: { id?: string | null; name?: string | null; description?: string | null } | null;
  product?: {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    iconPath?: string | null;
    osType?: ProductOsType | null;
    status?: ProductStatus | null;
    createdAt?: string | null;
  } | null;
  tasks?: Array<{
    id?: string | null;
    description?: string | null;
    flow?: {
      id?: string | null;
      name?: string | null;
      version?: string | null;
      status?: FlowStatus | null;
      isLocked?: boolean | null;
      medias?: Array<{
        id?: string | null;
        isFlowStartPage?: boolean | null;
        isTarget?: boolean | null;
        media?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null> | null;
  creatorUser?: {
    fullName?: string | null;
    email?: string | null;
    username?: string | null;
    mobile?: string | null;
    gender?: Gender | null;
    status?: UserStatus | null;
    avatar?: string | null;
  } | null;
  groups?: Array<{
    id?: string | null;
    name?: string | null;
    creatorUser?: {
      fullName?: string | null;
      email?: string | null;
      username?: string | null;
      mobile?: string | null;
      gender?: Gender | null;
      status?: UserStatus | null;
      avatar?: string | null;
    } | null;
  } | null> | null;
  publicLink?: { code?: string | null; status?: TestPublicLinkStatus | null } | null;
};

export type CreateTestMutationVariables = Exact<{
  data: CreateTestInputs;
  productId: Scalars['String']['input'];
}>;

export type CreateTestMutation = {
  createTest?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      description?: string | null;
      status?: TestStatus | null;
      goal?: string | null;
      scenario?: string | null;
      progressStatus?: TestProgressStatus | null;
      createdAt?: string | null;
    } | null;
  } | null;
};

export type GetTestQueryVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type GetTestQuery = {
  getTest?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      description?: string | null;
      status?: TestStatus | null;
      goal?: string | null;
      scenario?: string | null;
      progressStatus?: TestProgressStatus | null;
      createdAt?: string | null;
      type?: { id?: string | null; name?: string | null; description?: string | null } | null;
      product?: {
        id?: string | null;
        name?: string | null;
        description?: string | null;
        iconPath?: string | null;
        osType?: ProductOsType | null;
        status?: ProductStatus | null;
        createdAt?: string | null;
      } | null;
      tasks?: Array<{
        id?: string | null;
        description?: string | null;
        flow?: {
          id?: string | null;
          name?: string | null;
          version?: string | null;
          status?: FlowStatus | null;
          isLocked?: boolean | null;
          medias?: Array<{
            id?: string | null;
            isFlowStartPage?: boolean | null;
            isTarget?: boolean | null;
            media?: {
              id?: string | null;
              imagePath?: string | null;
              version?: string | null;
              title?: string | null;
              description?: string | null;
              source?: ImageSource | null;
              type?: { id?: string | null; name?: string | null } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null> | null;
      creatorUser?: {
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        status?: UserStatus | null;
        avatar?: string | null;
      } | null;
      groups?: Array<{
        id?: string | null;
        name?: string | null;
        creatorUser?: {
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          status?: UserStatus | null;
          avatar?: string | null;
        } | null;
      } | null> | null;
      publicLink?: { code?: string | null; status?: TestPublicLinkStatus | null } | null;
    } | null;
  } | null;
};

export type GetTestsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GetTestsFilters>;
}>;

export type GetTestsQuery = {
  getTests?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        name?: string | null;
        description?: string | null;
        status?: TestStatus | null;
        goal?: string | null;
        scenario?: string | null;
        progressStatus?: TestProgressStatus | null;
        createdAt?: string | null;
        type?: { id?: string | null; name?: string | null; description?: string | null } | null;
        product?: {
          id?: string | null;
          name?: string | null;
          description?: string | null;
          iconPath?: string | null;
          osType?: ProductOsType | null;
          status?: ProductStatus | null;
          createdAt?: string | null;
        } | null;
        tasks?: Array<{
          id?: string | null;
          description?: string | null;
          flow?: {
            id?: string | null;
            name?: string | null;
            version?: string | null;
            status?: FlowStatus | null;
            isLocked?: boolean | null;
            medias?: Array<{
              id?: string | null;
              isFlowStartPage?: boolean | null;
              isTarget?: boolean | null;
              media?: {
                id?: string | null;
                imagePath?: string | null;
                version?: string | null;
                title?: string | null;
                description?: string | null;
                source?: ImageSource | null;
                type?: { id?: string | null; name?: string | null } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null> | null;
        creatorUser?: {
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          status?: UserStatus | null;
          avatar?: string | null;
        } | null;
        groups?: Array<{
          id?: string | null;
          name?: string | null;
          creatorUser?: {
            fullName?: string | null;
            email?: string | null;
            username?: string | null;
            mobile?: string | null;
            gender?: Gender | null;
            status?: UserStatus | null;
            avatar?: string | null;
          } | null;
        } | null> | null;
        publicLink?: { code?: string | null; status?: TestPublicLinkStatus | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UpdateTestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  newData?: InputMaybe<UpdateTestInputs>;
}>;

export type UpdateTestMutation = {
  updateTest?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      description?: string | null;
      status?: TestStatus | null;
      goal?: string | null;
      scenario?: string | null;
      progressStatus?: TestProgressStatus | null;
      createdAt?: string | null;
    } | null;
  } | null;
};

export type DeleteTestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type DeleteTestMutation = {
  deleteTest?: { statusCode?: number | null; message?: string | null } | null;
};

export type StartTestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type StartTestMutation = {
  startTest?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      id?: string | null;
      name?: string | null;
      description?: string | null;
      status?: TestStatus | null;
      goal?: string | null;
      scenario?: string | null;
      progressStatus?: TestProgressStatus | null;
      createdAt?: string | null;
    } | null;
  } | null;
};

export type AssignTestToTesterGroupMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  taskIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<AssignTestToTesterGroupInputs>;
}>;

export type AssignTestToTesterGroupMutation = {
  assignTestToTesterGroup?: { statusCode?: number | null; message?: string | null } | null;
};

export type FinishTestMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;

export type FinishTestMutation = {
  finishTest?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      id?: string | null;
      name?: string | null;
      description?: string | null;
      status?: TestStatus | null;
      goal?: string | null;
      scenario?: string | null;
      progressStatus?: TestProgressStatus | null;
      createdAt?: string | null;
      type?: { id?: string | null; name?: string | null; description?: string | null } | null;
      product?: {
        id?: string | null;
        name?: string | null;
        description?: string | null;
        iconPath?: string | null;
        osType?: ProductOsType | null;
        status?: ProductStatus | null;
        createdAt?: string | null;
      } | null;
      tasks?: Array<{
        id?: string | null;
        description?: string | null;
        flow?: {
          id?: string | null;
          name?: string | null;
          version?: string | null;
          status?: FlowStatus | null;
          isLocked?: boolean | null;
          medias?: Array<{
            id?: string | null;
            isFlowStartPage?: boolean | null;
            isTarget?: boolean | null;
            media?: {
              id?: string | null;
              imagePath?: string | null;
              version?: string | null;
              title?: string | null;
              description?: string | null;
              source?: ImageSource | null;
              type?: { id?: string | null; name?: string | null } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null> | null;
      creatorUser?: {
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        status?: UserStatus | null;
        avatar?: string | null;
      } | null;
      groups?: Array<{
        id?: string | null;
        name?: string | null;
        creatorUser?: {
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          status?: UserStatus | null;
          avatar?: string | null;
        } | null;
      } | null> | null;
      publicLink?: { code?: string | null; status?: TestPublicLinkStatus | null } | null;
    } | null;
  } | null;
};

export type VerifyTestByPublicLinkQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type VerifyTestByPublicLinkQuery = {
  verifyTestByPublicLink?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      code?: string | null;
      status?: TestPublicLinkStatus | null;
      test?: {
        id?: string | null;
        name?: string | null;
        createdAt?: string | null;
        product?: { id?: string | null; name?: string | null; iconPath?: string | null } | null;
        tasks?: Array<{ id?: string | null; description?: string | null } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type SubscriptionPlanListOutputFragmentFragment = {
  data?: Array<{
    id?: string | null;
    name?: string | null;
    description?: string | null;
    price?: number | null;
    discount?: number | null;
    duration?: number | null;
    productLimit?: number | null;
    testLimit?: number | null;
    flowLimit?: number | null;
    testerLimit?: number | null;
    iconPath?: string | null;
    type?: SubscriptionPlanType | null;
    teamMemberLimit?: number | null;
    screenLimit?: number | null;
    responsePerStudy?: number | null;
    features?: Array<{ description?: string | null } | null> | null;
  } | null> | null;
};

export type GetSubscriptionPlansQueryVariables = Exact<{
  filters?: InputMaybe<GetSubscriptionPlanFilters>;
}>;

export type GetSubscriptionPlansQuery = {
  getSubscriptionPlans?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        name?: string | null;
        description?: string | null;
        price?: number | null;
        discount?: number | null;
        duration?: number | null;
        productLimit?: number | null;
        testLimit?: number | null;
        flowLimit?: number | null;
        testerLimit?: number | null;
        iconPath?: string | null;
        type?: SubscriptionPlanType | null;
        teamMemberLimit?: number | null;
        screenLimit?: number | null;
        responsePerStudy?: number | null;
        features?: Array<{ description?: string | null } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CheckoutQueryVariables = Exact<{
  subscriptionPlanId: Scalars['String']['input'];
}>;

export type CheckoutQuery = {
  checkout?: {
    message?: string | null;
    statusCode?: number | null;
    data?: { url?: string | null } | null;
  } | null;
};

export type GetPaymentQueryVariables = Exact<{
  paymentId: Scalars['String']['input'];
}>;

export type GetPaymentQuery = {
  getPayment?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      id?: string | null;
      invoiceNumber?: string | null;
      finalPrice?: number | null;
      status?: UserPaymentStatus | null;
      createdAt?: string | null;
      subscriptionPlan?: { name?: string | null } | null;
    } | null;
  } | null;
};

export type GetPaymentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPaymentsQuery = {
  getPayments?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        invoiceNumber?: string | null;
        invoiceId?: string | null;
        finalPrice?: number | null;
        status?: UserPaymentStatus | null;
        createdAt?: string | null;
        subscriptionPlan?: { name?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;

export type GetInvoiceQuery = {
  getInvoice?: { message?: string | null; statusCode?: number | null; data?: string | null } | null;
};

export type TaskFragmentFragment = {
  id?: string | null;
  description?: string | null;
  flow?: {
    id?: string | null;
    name?: string | null;
    version?: string | null;
    status?: FlowStatus | null;
    isLocked?: boolean | null;
    medias?: Array<{
      id?: string | null;
      isFlowStartPage?: boolean | null;
      isTarget?: boolean | null;
      media?: {
        id?: string | null;
        imagePath?: string | null;
        version?: string | null;
        title?: string | null;
        description?: string | null;
        source?: ImageSource | null;
        type?: { id?: string | null; name?: string | null } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CreateTestTaskMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  data: CreateTestTaskInputs;
}>;

export type CreateTestTaskMutation = {
  createTestTask?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      description?: string | null;
      flow?: {
        id?: string | null;
        name?: string | null;
        version?: string | null;
        status?: FlowStatus | null;
        isLocked?: boolean | null;
        medias?: Array<{
          id?: string | null;
          isFlowStartPage?: boolean | null;
          isTarget?: boolean | null;
          media?: {
            id?: string | null;
            imagePath?: string | null;
            version?: string | null;
            title?: string | null;
            description?: string | null;
            source?: ImageSource | null;
            type?: { id?: string | null; name?: string | null } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteTestTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
}>;

export type DeleteTestTaskMutation = {
  deleteTestTask?: { statusCode?: number | null; message?: string | null } | null;
};

export type UpdateTestTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  newData?: InputMaybe<UpdateTestTaskInputs>;
}>;

export type UpdateTestTaskMutation = {
  updateTestTask?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      description?: string | null;
      flow?: {
        id?: string | null;
        name?: string | null;
        version?: string | null;
        status?: FlowStatus | null;
        isLocked?: boolean | null;
        medias?: Array<{
          id?: string | null;
          isFlowStartPage?: boolean | null;
          isTarget?: boolean | null;
          media?: {
            id?: string | null;
            imagePath?: string | null;
            version?: string | null;
            title?: string | null;
            description?: string | null;
            source?: ImageSource | null;
            type?: { id?: string | null; name?: string | null } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type GetTestTaskQueryVariables = Exact<{
  id: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
}>;

export type GetTestTaskQuery = {
  getTestTask?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      description?: string | null;
      flow?: {
        id?: string | null;
        name?: string | null;
        version?: string | null;
        status?: FlowStatus | null;
        isLocked?: boolean | null;
        medias?: Array<{
          id?: string | null;
          isFlowStartPage?: boolean | null;
          isTarget?: boolean | null;
          media?: {
            id?: string | null;
            imagePath?: string | null;
            version?: string | null;
            title?: string | null;
            description?: string | null;
            source?: ImageSource | null;
            type?: { id?: string | null; name?: string | null } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type GenerateTestTaskByAiQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  testId: Scalars['String']['input'];
  flowId: Scalars['String']['input'];
}>;

export type GenerateTestTaskByAiQuery = {
  generateTestTaskByAi?: {
    message?: string | null;
    statusCode?: number | null;
    data?: string | null;
  } | null;
};

export type TesterUserFragmentFragment = {
  id?: string | null;
  fullName?: string | null;
  email?: string | null;
  username?: string | null;
  mobile?: string | null;
  gender?: Gender | null;
  registrationStatus?: TesterUserRegistrationStatus | null;
  birthYear?: string | null;
  defaultHand?: DefaultHand | null;
  handSize?: HandSize | null;
  avatar?: string | null;
  displayName?: string | null;
  country?: { name?: string | null } | null;
};

export type PureTesterTestFragmentFragment = {
  id?: string | null;
  actionStatus?: TesterUserTestActionStatus | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  totalDuration?: number | null;
};

export type TesterTestFragmentFragment = {
  id?: string | null;
  actionStatus?: TesterUserTestActionStatus | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  totalDuration?: number | null;
  test?: {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    status?: TestStatus | null;
    goal?: string | null;
    scenario?: string | null;
    progressStatus?: TestProgressStatus | null;
    createdAt?: string | null;
  } | null;
  task?: {
    id?: string | null;
    description?: string | null;
    flow?: {
      id?: string | null;
      name?: string | null;
      version?: string | null;
      status?: FlowStatus | null;
      isLocked?: boolean | null;
      medias?: Array<{
        id?: string | null;
        isFlowStartPage?: boolean | null;
        isTarget?: boolean | null;
        media?: {
          id?: string | null;
          imagePath?: string | null;
          version?: string | null;
          title?: string | null;
          description?: string | null;
          source?: ImageSource | null;
          type?: { id?: string | null; name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  testerUser?: {
    id?: string | null;
    fullName?: string | null;
    email?: string | null;
    username?: string | null;
    mobile?: string | null;
    gender?: Gender | null;
    registrationStatus?: TesterUserRegistrationStatus | null;
    birthYear?: string | null;
    defaultHand?: DefaultHand | null;
    handSize?: HandSize | null;
    avatar?: string | null;
    displayName?: string | null;
    country?: { name?: string | null } | null;
  } | null;
};

export type TestGroupFragmentFragment = {
  id?: string | null;
  name?: string | null;
  creatorUser?: {
    fullName?: string | null;
    email?: string | null;
    username?: string | null;
    mobile?: string | null;
    gender?: Gender | null;
    status?: UserStatus | null;
    avatar?: string | null;
  } | null;
};

export type GetTestGroupQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetTestGroupQuery = {
  getTestGroup?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      creatorUser?: {
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        status?: UserStatus | null;
        avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type CreateTestGroupMutationVariables = Exact<{
  data: CreateTestGroupInputs;
}>;

export type CreateTestGroupMutation = {
  createTestGroup?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      creatorUser?: {
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        status?: UserStatus | null;
        avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateTestGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
  newData?: InputMaybe<UpdateTestGroupInputs>;
}>;

export type UpdateTestGroupMutation = {
  updateTestGroup?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      name?: string | null;
      creatorUser?: {
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        status?: UserStatus | null;
        avatar?: string | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteTestGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteTestGroupMutation = {
  deleteTestGroup?: { statusCode?: number | null; message?: string | null } | null;
};

export type GetTestGroupsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetTestGroupsQuery = {
  getTestGroups?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        name?: string | null;
        creatorUser?: {
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          status?: UserStatus | null;
          avatar?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type TesterUserFetchOrCreateMutationVariables = Exact<{
  data?: InputMaybe<TesterUserFetchOrCreateInputs>;
}>;

export type TesterUserFetchOrCreateMutation = {
  testerUserFetchOrCreate?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      fullName?: string | null;
      email?: string | null;
      username?: string | null;
      mobile?: string | null;
      gender?: Gender | null;
      registrationStatus?: TesterUserRegistrationStatus | null;
      birthYear?: string | null;
      defaultHand?: DefaultHand | null;
      handSize?: HandSize | null;
      avatar?: string | null;
      displayName?: string | null;
      country?: { name?: string | null } | null;
    } | null;
  } | null;
};

export type CreateTestGroupMemberMutationVariables = Exact<{
  data?: InputMaybe<CreateTestGroupMemberInputs>;
}>;

export type CreateTestGroupMemberMutation = {
  createTestGroupMember?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      testerUser?: {
        id?: string | null;
        fullName?: string | null;
        email?: string | null;
        username?: string | null;
        mobile?: string | null;
        gender?: Gender | null;
        registrationStatus?: TesterUserRegistrationStatus | null;
        birthYear?: string | null;
        defaultHand?: DefaultHand | null;
        handSize?: HandSize | null;
        avatar?: string | null;
        displayName?: string | null;
        country?: { name?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteGroupMemberMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteGroupMemberMutation = {
  deleteTestGroupMember?: { statusCode?: number | null; message?: string | null } | null;
};

export type GetTestGroupMembersQueryVariables = Exact<{
  filters: GetTestGroupMembersFilters;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetTestGroupMembersQuery = {
  getTestGroupMembers?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      totalCount?: number | null;
      currentPage?: number | null;
      data?: Array<{
        id?: string | null;
        testerUser?: {
          id?: string | null;
          fullName?: string | null;
          email?: string | null;
          username?: string | null;
          mobile?: string | null;
          gender?: Gender | null;
          registrationStatus?: TesterUserRegistrationStatus | null;
          birthYear?: string | null;
          defaultHand?: DefaultHand | null;
          handSize?: HandSize | null;
          avatar?: string | null;
          displayName?: string | null;
          country?: { name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetTesterQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetTesterQuery = {
  getTester?: {
    statusCode?: number | null;
    message?: string | null;
    data?: {
      id?: string | null;
      fullName?: string | null;
      email?: string | null;
      username?: string | null;
      mobile?: string | null;
      gender?: Gender | null;
      registrationStatus?: TesterUserRegistrationStatus | null;
      birthYear?: string | null;
      defaultHand?: DefaultHand | null;
      handSize?: HandSize | null;
      avatar?: string | null;
      displayName?: string | null;
      country?: { name?: string | null } | null;
    } | null;
  } | null;
};

export type CreateWorkspaceTesterMutationVariables = Exact<{
  data?: InputMaybe<CreateWorkspaceTesterInputs>;
}>;

export type CreateWorkspaceTesterMutation = {
  createWorkspaceTester?: { message?: string | null; statusCode?: number | null } | null;
};

export type ResendTesterInvitationMutationVariables = Exact<{
  testId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  testerId: Scalars['String']['input'];
}>;

export type ResendTesterInvitationMutation = {
  resendTesterInvitation?: { message?: string | null; statusCode?: number | null } | null;
};

export type GetUploadPresignedUrlQueryVariables = Exact<{
  data: GetUploadPresignedUrlInputs;
  type?: InputMaybe<FileUploadType>;
}>;

export type GetUploadPresignedUrlQuery = {
  getUploadPresignedURL?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { url?: string | null; validFor?: number | null; key?: string | null } | null;
  } | null;
};

export type UserFragmentFragment = {
  fullName?: string | null;
  email?: string | null;
  username?: string | null;
  mobile?: string | null;
  gender?: Gender | null;
  status?: UserStatus | null;
  avatar?: string | null;
};

export type UpdateProfileMutationVariables = Exact<{
  newData?: InputMaybe<UpdateProfileInputs>;
}>;

export type UpdateProfileMutation = {
  updateProfile?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { at?: string | null; rt?: string | null } | null;
  } | null;
};

export type UpdateWorkspaceMutationVariables = Exact<{
  newData?: InputMaybe<UpdateWorkspaceInputs>;
}>;

export type UpdateWorkspaceMutation = {
  updateWorkspace?: {
    message?: string | null;
    statusCode?: number | null;
    data?: { id?: string | null; name?: string | null; description?: string | null } | null;
  } | null;
};

export type GetWorkspaceStatisticsQueryVariables = Exact<{ [key: string]: never }>;

export type GetWorkspaceStatisticsQuery = {
  getWorkspaceStatistics?: {
    message?: string | null;
    statusCode?: number | null;
    data?: {
      product?: { count?: number | null; available?: number | null } | null;
      flow?: { count?: number | null; available?: number | null } | null;
      study?: { count?: number | null; available?: number | null } | null;
    } | null;
  } | null;
};

export const ScreenTypeFragmentFragmentDoc = gql`
  fragment ScreenTypeFragment on ScreenType {
    id
    name
  }
`;
export const ProductMediaFragmentFragmentDoc = gql`
  fragment ProductMediaFragment on ProductMedia {
    id
    imagePath
    version
    title
    description
    source
    type {
      ...ScreenTypeFragment
    }
  }
  ${ScreenTypeFragmentFragmentDoc}
`;
export const FlowMediaWithoutLinksFragmentFragmentDoc = gql`
  fragment FlowMediaWithoutLinksFragment on FlowMedia {
    id
    isFlowStartPage
    isTarget
    media {
      ...ProductMediaFragment
    }
  }
  ${ProductMediaFragmentFragmentDoc}
`;
export const FlowMediaLinkFragmentFragmentDoc = gql`
  fragment FlowMediaLinkFragment on FlowMediaLink {
    linkToMedia {
      ...ProductMediaFragment
    }
    id
    startX
    startY
    endX
    endY
    isFlowTap
  }
  ${ProductMediaFragmentFragmentDoc}
`;
export const FlowMediaFragmentFragmentDoc = gql`
  fragment FlowMediaFragment on FlowMedia {
    ...FlowMediaWithoutLinksFragment
    links {
      ...FlowMediaLinkFragment
    }
  }
  ${FlowMediaWithoutLinksFragmentFragmentDoc}
  ${FlowMediaLinkFragmentFragmentDoc}
`;
export const FigmaImportTokenDataFragmentFragmentDoc = gql`
  fragment figmaImportTokenDataFragment on FigmaImportTokenDataOutput {
    token
    validFor
  }
`;
export const PureTesterIssueFragmentFragmentDoc = gql`
  fragment PureTesterIssueFragment on TesterIssue {
    id
    issuePriority
    issueType
    issueCategory
    issueDescription
    createdAt
  }
`;
export const PureTestFragmentFragmentDoc = gql`
  fragment PureTestFragment on Test {
    id
    name
    description
    status
    goal
    scenario
    progressStatus
    createdAt
  }
`;
export const TesterUserFragmentFragmentDoc = gql`
  fragment TesterUserFragment on TesterUser {
    id
    fullName
    email
    username
    mobile
    gender
    registrationStatus
    birthYear
    defaultHand
    handSize
    avatar
    displayName
    country {
      name
    }
  }
`;
export const FlowFragmentFragmentDoc = gql`
  fragment FlowFragment on Flow {
    id
    name
    version
    status
    isLocked
    medias {
      ...FlowMediaWithoutLinksFragment
    }
  }
  ${FlowMediaWithoutLinksFragmentFragmentDoc}
`;
export const TaskFragmentFragmentDoc = gql`
  fragment TaskFragment on Task {
    id
    description
    flow {
      ...FlowFragment
    }
  }
  ${FlowFragmentFragmentDoc}
`;
export const TesterIssueFragmentFragmentDoc = gql`
  fragment TesterIssueFragment on TesterIssue {
    ...PureTesterIssueFragment
    test {
      ...PureTestFragment
    }
    tester {
      ...TesterUserFragment
    }
    task {
      ...TaskFragment
    }
  }
  ${PureTesterIssueFragmentFragmentDoc}
  ${PureTestFragmentFragmentDoc}
  ${TesterUserFragmentFragmentDoc}
  ${TaskFragmentFragmentDoc}
`;
export const ProductPersonaFragmentFragmentDoc = gql`
  fragment ProductPersonaFragment on ProductPersona {
    id
    name
    behavior
    bio
    goal
    fromAge
    toAge
    targetGender
  }
`;
export const PureProductFragmentFragmentDoc = gql`
  fragment PureProductFragment on Product {
    id
    name
    description
    iconPath
    osType
    status
    createdAt
  }
`;
export const CategoryFragmentFragmentDoc = gql`
  fragment CategoryFragment on Category {
    id
    name
  }
`;
export const UserFragmentFragmentDoc = gql`
  fragment UserFragment on User {
    fullName
    email
    username
    mobile
    gender
    status
    avatar
  }
`;
export const ProductActionHistoryFragmentFragmentDoc = gql`
  fragment ProductActionHistoryFragment on ProductActionHistory {
    issuedByUser {
      ...UserFragment
    }
    log
    actionType
    createdAt
  }
  ${UserFragmentFragmentDoc}
`;
export const ProductFragmentFragmentDoc = gql`
  fragment ProductFragment on Product {
    ...PureProductFragment
    category {
      ...CategoryFragment
    }
    creatorUser {
      ...UserFragment
    }
    workspace {
      id
      name
    }
    actionHistory {
      ...ProductActionHistoryFragment
    }
  }
  ${PureProductFragmentFragmentDoc}
  ${CategoryFragmentFragmentDoc}
  ${UserFragmentFragmentDoc}
  ${ProductActionHistoryFragmentFragmentDoc}
`;
export const GetGenderReportOutputDataFragmentFragmentDoc = gql`
  fragment GetGenderReportOutputDataFragment on GetGenderReportOutputData {
    MALE
    FEMALE
    NON_BINARY
  }
`;
export const GetHandHoldPositionReportFullObjectFragmentFragmentDoc = gql`
  fragment GetHandHoldPositionReportFullObjectFragment on GetHandHoldPositionReportFullObject {
    CRADLED {
      count
      percentage
    }
    HOLD_AND_TOUCH {
      count
      percentage
    }
    ONE_HAND_FIRST_ORDER {
      count
      percentage
    }
    ONE_HAND_SECOND_ORDER {
      count
      percentage
    }
    TWO_HANDS_PORTRAIT {
      count
      percentage
    }
    TWO_HANDS_LANDSCAPE {
      count
      percentage
    }
  }
`;
export const GetDefaultHandReportOutputDataFragmentFragmentDoc = gql`
  fragment GetDefaultHandReportOutputDataFragment on GetDefaultHandReportOutputData {
    LEFT
    RIGHT
  }
`;
export const GetDeviceTypeReportOutputDataFragmentFragmentDoc = gql`
  fragment GetDeviceTypeReportOutputDataFragment on GetDeviceTypeReportOutputData {
    ANDROID
    IPHONE
  }
`;
export const TestTypeFragmentFragmentDoc = gql`
  fragment TestTypeFragment on TestType {
    id
    name
    description
  }
`;
export const TestGroupFragmentFragmentDoc = gql`
  fragment TestGroupFragment on TestGroup {
    id
    name
    creatorUser {
      ...UserFragment
    }
  }
  ${UserFragmentFragmentDoc}
`;
export const TestFragmentFragmentDoc = gql`
  fragment TestFragment on Test {
    ...PureTestFragment
    type {
      ...TestTypeFragment
    }
    product {
      ...PureProductFragment
    }
    tasks {
      ...TaskFragment
    }
    creatorUser {
      ...UserFragment
    }
    groups {
      ...TestGroupFragment
    }
    publicLink {
      code
      status
    }
  }
  ${PureTestFragmentFragmentDoc}
  ${TestTypeFragmentFragmentDoc}
  ${PureProductFragmentFragmentDoc}
  ${TaskFragmentFragmentDoc}
  ${UserFragmentFragmentDoc}
  ${TestGroupFragmentFragmentDoc}
`;
export const SubscriptionPlanListOutputFragmentFragmentDoc = gql`
  fragment SubscriptionPlanListOutputFragment on SubscriptionPlanListOutput {
    data {
      id
      name
      description
      price
      discount
      duration
      productLimit
      testLimit
      flowLimit
      testerLimit
      iconPath
      type
      teamMemberLimit
      screenLimit
      responsePerStudy
      features {
        description
      }
    }
  }
`;
export const PureTesterTestFragmentFragmentDoc = gql`
  fragment PureTesterTestFragment on TesterTest {
    id
    actionStatus
    createdAt
    updatedAt
    totalDuration
  }
`;
export const TesterTestFragmentFragmentDoc = gql`
  fragment TesterTestFragment on TesterTest {
    ...PureTesterTestFragment
    test {
      ...PureTestFragment
    }
    task {
      ...TaskFragment
    }
    testerUser {
      ...TesterUserFragment
    }
  }
  ${PureTesterTestFragmentFragmentDoc}
  ${PureTestFragmentFragmentDoc}
  ${TaskFragmentFragmentDoc}
  ${TesterUserFragmentFragmentDoc}
`;
export const RequestLoginDocument = gql`
  query requestLogin($email: String!) {
    userRequestLogin(email: $email) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestLoginQueryService extends Apollo.Query<
  RequestLoginQuery,
  RequestLoginQueryVariables
> {
  override document = RequestLoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserLoginDocument = gql`
  query userLogin($email: String!, $verificationCode: String!) {
    userLogin(email: $email, verificationCode: $verificationCode) {
      statusCode
      message
      data {
        at
        rt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UserLoginQueryService extends Apollo.Query<UserLoginQuery, UserLoginQueryVariables> {
  override document = UserLoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RefreshTokenDocument = gql`
  mutation refreshToken {
    refreshToken {
      statusCode
      message
      data {
        at
        rt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenMutationService extends Apollo.Mutation<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
> {
  override document = RefreshTokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LogoutDocument = gql`
  mutation logout {
    logout {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LogoutMutationService extends Apollo.Mutation<
  LogoutMutation,
  LogoutMutationVariables
> {
  override document = LogoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCategoriesDocument = gql`
  query getCategories($page: Int = 1, $filters: CategoryListFilters) {
    getCategories(page: $page, filters: $filters) {
      data {
        totalCount
        currentPage
        data {
          ...CategoryFragment
        }
      }
      statusCode
      message
    }
  }
  ${CategoryFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetCategoriesQueryService extends Apollo.Query<
  GetCategoriesQuery,
  GetCategoriesQueryVariables
> {
  override document = GetCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateFlowMediaLinkDocument = gql`
  mutation createFlowMediaLink(
    $data: CreateFlowMediaLinkInputs!
    $flowMediaId: String!
    $productId: String!
  ) {
    createFlowMediaLink(data: $data, productId: $productId, flowMediaId: $flowMediaId) {
      data {
        ...FlowMediaLinkFragment
      }
      statusCode
      message
    }
  }
  ${FlowMediaLinkFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateFlowMediaLinkMutationService extends Apollo.Mutation<
  CreateFlowMediaLinkMutation,
  CreateFlowMediaLinkMutationVariables
> {
  override document = CreateFlowMediaLinkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateFlowMediaLinkDocument = gql`
  mutation updateFlowMediaLink(
    $id: String!
    $flowMediaId: String!
    $productId: String!
    $newData: UpdateFlowMediaLinkInputs
  ) {
    updateFlowMediaLink(
      id: $id
      newData: $newData
      productId: $productId
      flowMediaId: $flowMediaId
    ) {
      data {
        ...FlowMediaLinkFragment
      }
      statusCode
      message
    }
  }
  ${FlowMediaLinkFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateFlowMediaLinkMutationService extends Apollo.Mutation<
  UpdateFlowMediaLinkMutation,
  UpdateFlowMediaLinkMutationVariables
> {
  override document = UpdateFlowMediaLinkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteFlowMediaLinkDocument = gql`
  mutation deleteFlowMediaLink($id: String!, $flowMediaId: String!, $productId: String!) {
    deleteFlowMediaLink(id: $id, productId: $productId, flowMediaId: $flowMediaId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteFlowMediaLinkMutationService extends Apollo.Mutation<
  DeleteFlowMediaLinkMutation,
  DeleteFlowMediaLinkMutationVariables
> {
  override document = DeleteFlowMediaLinkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFlowMediasDocument = gql`
  query getFlowMedias(
    $flowId: String!
    $productId: String!
    $filters: GetFlowMediaFilters
    $page: Int = 1
  ) {
    getFlowMedias(flowId: $flowId, productId: $productId, filters: $filters, page: $page) {
      data {
        totalCount
        currentPage
        data {
          ...FlowMediaWithoutLinksFragment
        }
      }
      statusCode
      message
    }
  }
  ${FlowMediaWithoutLinksFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFlowMediasQueryService extends Apollo.Query<
  GetFlowMediasQuery,
  GetFlowMediasQueryVariables
> {
  override document = GetFlowMediasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFlowMediaDocument = gql`
  query getFlowMedia($id: String!, $flowId: String!, $productId: String!) {
    getFlowMedia(id: $id, flowId: $flowId, productId: $productId) {
      data {
        ...FlowMediaFragment
      }
      statusCode
      message
    }
  }
  ${FlowMediaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFlowMediaQueryService extends Apollo.Query<
  GetFlowMediaQuery,
  GetFlowMediaQueryVariables
> {
  override document = GetFlowMediaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateFlowMediaDocument = gql`
  mutation createFlowMedia($data: CreateFlowMediaInputs!, $productId: String!) {
    createFlowMedia(data: $data, productId: $productId) {
      data {
        ...FlowMediaFragment
      }
      statusCode
      message
    }
  }
  ${FlowMediaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateFlowMediaMutationService extends Apollo.Mutation<
  CreateFlowMediaMutation,
  CreateFlowMediaMutationVariables
> {
  override document = CreateFlowMediaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateFlowMediasDocument = gql`
  mutation createFlowMedias($data: [CreateFlowMediaInputs]!, $productId: String!) {
    createFlowMedias(data: $data, productId: $productId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateFlowMediasMutationService extends Apollo.Mutation<
  CreateFlowMediasMutation,
  CreateFlowMediasMutationVariables
> {
  override document = CreateFlowMediasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateFlowMediasDocument = gql`
  mutation updateFlowMedias($newData: [UpdateFlowMediasInputs]!, $productId: String!) {
    updateFlowMedias(newData: $newData, productId: $productId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateFlowMediasMutationService extends Apollo.Mutation<
  UpdateFlowMediasMutation,
  UpdateFlowMediasMutationVariables
> {
  override document = UpdateFlowMediasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteFlowMediaDocument = gql`
  mutation deleteFlowMedia($data: DeleteFlowMediaInputs!, $productId: String!) {
    deleteFlowMedia(data: $data, productId: $productId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteFlowMediaMutationService extends Apollo.Mutation<
  DeleteFlowMediaMutation,
  DeleteFlowMediaMutationVariables
> {
  override document = DeleteFlowMediaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFlowsDocument = gql`
  query getFlows($productId: String!, $filters: GetFlowsFilters, $page: Int = 1) {
    getFlows(productId: $productId, page: $page, filters: $filters) {
      data {
        data {
          ...FlowFragment
        }
        totalCount
        currentPage
      }
      statusCode
      message
    }
  }
  ${FlowFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFlowsQueryService extends Apollo.Query<GetFlowsQuery, GetFlowsQueryVariables> {
  override document = GetFlowsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFlowDocument = gql`
  query getFlow($id: String!, $productId: String!) {
    getFlow(id: $id, productId: $productId) {
      data {
        ...FlowFragment
      }
      statusCode
      message
    }
  }
  ${FlowFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetFlowQueryService extends Apollo.Query<GetFlowQuery, GetFlowQueryVariables> {
  override document = GetFlowDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateFlowDocument = gql`
  mutation createFlow($data: CreateFlowInputs!, $productId: String!) {
    createFlow(data: $data, productId: $productId) {
      data {
        ...FlowFragment
      }
      statusCode
      message
    }
  }
  ${FlowFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateFlowMutationService extends Apollo.Mutation<
  CreateFlowMutation,
  CreateFlowMutationVariables
> {
  override document = CreateFlowDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateFlowDocument = gql`
  mutation updateFlow($id: String!, $productId: String!, $newData: UpdateFlowInputs) {
    updateFlow(id: $id, newData: $newData, productId: $productId) {
      data {
        ...FlowFragment
      }
      statusCode
      message
    }
  }
  ${FlowFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateFlowMutationService extends Apollo.Mutation<
  UpdateFlowMutation,
  UpdateFlowMutationVariables
> {
  override document = UpdateFlowDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteFlowDocument = gql`
  mutation deleteFlow($id: String!, $productId: String!) {
    deleteFlow(id: $id, productId: $productId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteFlowMutationService extends Apollo.Mutation<
  DeleteFlowMutation,
  DeleteFlowMutationVariables
> {
  override document = DeleteFlowDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateFigmaImportTokenDocument = gql`
  mutation createFigmaImportToken($productId: String!) {
    createFigmaImportToken(productId: $productId) {
      message
      statusCode
      data {
        ...figmaImportTokenDataFragment
      }
    }
  }
  ${FigmaImportTokenDataFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateFigmaImportTokenMutationService extends Apollo.Mutation<
  CreateFigmaImportTokenMutation,
  CreateFigmaImportTokenMutationVariables
> {
  override document = CreateFigmaImportTokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WatchImportDocument = gql`
  subscription watchImport($token: String!) {
    watchImport(token: $token) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class WatchImportSubscriptionService extends Apollo.Subscription<
  WatchImportSubscription,
  WatchImportSubscriptionVariables
> {
  override document = WatchImportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestIssuesDocument = gql`
  query getTestIssues(
    $productId: String!
    $testId: String!
    $filters: GetTestIssuesFilters
    $page: Int = 1
  ) {
    getTestIssues(productId: $productId, testId: $testId, filters: $filters, page: $page) {
      statusCode
      message
      data {
        data {
          ...PureTesterIssueFragment
        }
        totalCount
        currentPage
      }
    }
  }
  ${PureTesterIssueFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestIssuesQueryService extends Apollo.Query<
  GetTestIssuesQuery,
  GetTestIssuesQueryVariables
> {
  override document = GetTestIssuesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestIssueDocument = gql`
  query getTestIssue($id: String!, $productId: String!, $testId: String!) {
    getTestIssue(id: $id, productId: $productId, testId: $testId) {
      statusCode
      message
      data {
        ...TesterIssueFragment
      }
    }
  }
  ${TesterIssueFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestIssueQueryService extends Apollo.Query<
  GetTestIssueQuery,
  GetTestIssueQueryVariables
> {
  override document = GetTestIssueDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestIssuesSummaryDocument = gql`
  query getTestIssuesSummary(
    $productId: String!
    $testId: String!
    $filters: GetTestIssuesSummaryFilters
  ) {
    getTestIssuesSummary(productId: $productId, testId: $testId, filters: $filters) {
      statusCode
      message
      data {
        issueType
        summery
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestIssuesSummaryQueryService extends Apollo.Query<
  GetTestIssuesSummaryQuery,
  GetTestIssuesSummaryQueryVariables
> {
  override document = GetTestIssuesSummaryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductMediasDocument = gql`
  query getProductMedias($productId: String!, $page: Int = 1, $filters: ProductMediaListFilters) {
    getProductMedias(productId: $productId, page: $page, filters: $filters) {
      data {
        data {
          ...ProductMediaFragment
        }
        totalCount
        currentPage
      }
      statusCode
      message
    }
  }
  ${ProductMediaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductMediasQueryService extends Apollo.Query<
  GetProductMediasQuery,
  GetProductMediasQueryVariables
> {
  override document = GetProductMediasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductIncompleteMediasDocument = gql`
  query getProductIncompleteMedias($productId: String!, $page: Int = 1) {
    getProductIncompleteMedias(productId: $productId, page: $page) {
      data {
        data {
          ...ProductMediaFragment
        }
        totalCount
        currentPage
      }
      statusCode
      message
    }
  }
  ${ProductMediaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductIncompleteMediasQueryService extends Apollo.Query<
  GetProductIncompleteMediasQuery,
  GetProductIncompleteMediasQueryVariables
> {
  override document = GetProductIncompleteMediasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductMediaDocument = gql`
  query getProductMedia($id: String!, $productId: String!) {
    getProductMedia(id: $id, productId: $productId) {
      data {
        ...ProductMediaFragment
      }
      statusCode
      message
    }
  }
  ${ProductMediaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductMediaQueryService extends Apollo.Query<
  GetProductMediaQuery,
  GetProductMediaQueryVariables
> {
  override document = GetProductMediaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateProductMediaDocument = gql`
  mutation createProductMedia($data: CreateProductMediaInputs!, $productId: String!) {
    createProductMedia(data: $data, productId: $productId) {
      data {
        ...ProductMediaFragment
      }
      statusCode
      message
    }
  }
  ${ProductMediaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateProductMediaMutationService extends Apollo.Mutation<
  CreateProductMediaMutation,
  CreateProductMediaMutationVariables
> {
  override document = CreateProductMediaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateProductMediaDocument = gql`
  mutation updateProductMedia(
    $id: String!
    $productId: String!
    $newData: UpdateProductMediaInputs!
  ) {
    updateProductMedia(id: $id, newData: $newData, productId: $productId) {
      data {
        ...ProductMediaFragment
      }
      statusCode
      message
    }
  }
  ${ProductMediaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateProductMediaMutationService extends Apollo.Mutation<
  UpdateProductMediaMutation,
  UpdateProductMediaMutationVariables
> {
  override document = UpdateProductMediaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteProductMediaDocument = gql`
  mutation deleteProductMedia($id: String!, $productId: String!) {
    deleteProductMedia(id: $id, productId: $productId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteProductMediaMutationService extends Apollo.Mutation<
  DeleteProductMediaMutation,
  DeleteProductMediaMutationVariables
> {
  override document = DeleteProductMediaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetScreenTypesDocument = gql`
  query getScreenTypes($page: Int = 1, $filters: ScreenTypeFilter) {
    getScreenTypes(page: $page, filters: $filters) {
      data {
        totalCount
        currentPage
        data {
          id
          name
        }
      }
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetScreenTypesQueryService extends Apollo.Query<
  GetScreenTypesQuery,
  GetScreenTypesQueryVariables
> {
  override document = GetScreenTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GenerateProductPersonaDocument = gql`
  query generateProductPersona($categoryId: String!, $productId: String!) {
    generateProductPersona(categoryId: $categoryId, productId: $productId) {
      data {
        ...ProductPersonaFragment
      }
      statusCode
      message
    }
  }
  ${ProductPersonaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GenerateProductPersonaQueryService extends Apollo.Query<
  GenerateProductPersonaQuery,
  GenerateProductPersonaQueryVariables
> {
  override document = GenerateProductPersonaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductPersonasDocument = gql`
  query getProductPersonas($productId: String!, $page: Int = 1) {
    getProductPersonas(productId: $productId, page: $page) {
      data {
        data {
          ...ProductPersonaFragment
        }
        totalCount
        currentPage
      }
      statusCode
      message
    }
  }
  ${ProductPersonaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductPersonasQueryService extends Apollo.Query<
  GetProductPersonasQuery,
  GetProductPersonasQueryVariables
> {
  override document = GetProductPersonasDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductPersonaDocument = gql`
  query getProductPersona($id: String!, $productId: String!) {
    getProductPersona(id: $id, productId: $productId) {
      data {
        ...ProductPersonaFragment
      }
      statusCode
      message
    }
  }
  ${ProductPersonaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductPersonaQueryService extends Apollo.Query<
  GetProductPersonaQuery,
  GetProductPersonaQueryVariables
> {
  override document = GetProductPersonaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateProductPersonaDocument = gql`
  mutation createProductPersona($data: CreateProductPersonaInputs!, $productId: String!) {
    createProductPersona(data: $data, productId: $productId) {
      data {
        ...ProductPersonaFragment
      }
      statusCode
      message
    }
  }
  ${ProductPersonaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateProductPersonaMutationService extends Apollo.Mutation<
  CreateProductPersonaMutation,
  CreateProductPersonaMutationVariables
> {
  override document = CreateProductPersonaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateProductPersonaDocument = gql`
  mutation updateProductPersona(
    $id: String!
    $productId: String!
    $newData: UpdateProductPersonaInputs
  ) {
    updateProductPersona(id: $id, productId: $productId, newData: $newData) {
      data {
        ...ProductPersonaFragment
      }
      statusCode
      message
    }
  }
  ${ProductPersonaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateProductPersonaMutationService extends Apollo.Mutation<
  UpdateProductPersonaMutation,
  UpdateProductPersonaMutationVariables
> {
  override document = UpdateProductPersonaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteProductPersonaDocument = gql`
  mutation deleteProductPersona($id: String!, $productId: String!) {
    deleteProductPersona(id: $id, productId: $productId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteProductPersonaMutationService extends Apollo.Mutation<
  DeleteProductPersonaMutation,
  DeleteProductPersonaMutationVariables
> {
  override document = DeleteProductPersonaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductsDocument = gql`
  query getProducts($page: Int = 1, $filters: GetProductsFilters) {
    getProducts(page: $page, filters: $filters) {
      data {
        totalCount
        currentPage
        data {
          ...ProductFragment
        }
      }
      statusCode
      message
    }
  }
  ${ProductFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductsQueryService extends Apollo.Query<
  GetProductsQuery,
  GetProductsQueryVariables
> {
  override document = GetProductsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProductDocument = gql`
  query getProduct($id: String!) {
    getProduct(id: $id) {
      data {
        ...ProductFragment
      }
      statusCode
      message
    }
  }
  ${ProductFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetProductQueryService extends Apollo.Query<
  GetProductQuery,
  GetProductQueryVariables
> {
  override document = GetProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateProductDocument = gql`
  mutation createProduct($data: CreateProductInputs!) {
    createProduct(data: $data) {
      data {
        ...ProductFragment
      }
      statusCode
      message
    }
  }
  ${ProductFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateProductMutationService extends Apollo.Mutation<
  CreateProductMutation,
  CreateProductMutationVariables
> {
  override document = CreateProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateProductDocument = gql`
  mutation updateProduct($id: String!, $newData: UpdateProductInputs) {
    updateProduct(newData: $newData, id: $id) {
      data {
        ...ProductFragment
      }
      statusCode
      message
    }
  }
  ${ProductFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateProductMutationService extends Apollo.Mutation<
  UpdateProductMutation,
  UpdateProductMutationVariables
> {
  override document = UpdateProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteProductDocument = gql`
  mutation deleteProduct($id: String!) {
    deleteProduct(id: $id) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteProductMutationService extends Apollo.Mutation<
  DeleteProductMutation,
  DeleteProductMutationVariables
> {
  override document = DeleteProductDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTesterReportDocument = gql`
  query getTesterReport($testId: String!, $productId: String!) {
    getTesterReport(testId: $testId, productId: $productId) {
      data {
        age
        gender {
          ...GetGenderReportOutputDataFragment
        }
        handHoldPosition {
          ...GetHandHoldPositionReportFullObjectFragment
        }
        defaultHand {
          ...GetDefaultHandReportOutputDataFragment
        }
        deviceType {
          ...GetDeviceTypeReportOutputDataFragment
        }
      }
      statusCode
      message
    }
  }
  ${GetGenderReportOutputDataFragmentFragmentDoc}
  ${GetHandHoldPositionReportFullObjectFragmentFragmentDoc}
  ${GetDefaultHandReportOutputDataFragmentFragmentDoc}
  ${GetDeviceTypeReportOutputDataFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTesterReportQueryService extends Apollo.Query<
  GetTesterReportQuery,
  GetTesterReportQueryVariables
> {
  override document = GetTesterReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTesterTestQuickReportDocument = gql`
  query getTesterTestQuickReport($testId: String!, $productId: String!) {
    getTesterTestQuickReport(testId: $testId, productId: $productId) {
      data {
        fullName
        totalDuration
        task {
          ...TaskFragment
        }
      }
      statusCode
      message
    }
  }
  ${TaskFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTesterTestQuickReportQueryService extends Apollo.Query<
  GetTesterTestQuickReportQuery,
  GetTesterTestQuickReportQueryVariables
> {
  override document = GetTesterTestQuickReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTesterTestReportInfoDocument = gql`
  query getTesterTestReportInfo($testId: String!, $productId: String!, $taskId: String!) {
    getTesterTestReportInfo(testId: $testId, productId: $productId, taskId: $taskId) {
      data {
        testers {
          ...TesterUserFragment
        }
        medias {
          isFlowStartPage
          media {
            ...ProductMediaFragment
          }
        }
      }
      statusCode
      message
    }
  }
  ${TesterUserFragmentFragmentDoc}
  ${ProductMediaFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTesterTestReportInfoQueryService extends Apollo.Query<
  GetTesterTestReportInfoQuery,
  GetTesterTestReportInfoQueryVariables
> {
  override document = GetTesterTestReportInfoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetStudyFullTapReportDocument = gql`
  query getStudyFullTapReport(
    $productId: String!
    $testId: String!
    $taskId: String!
    $mediaId: String!
    $testerId: String
  ) {
    getStudyFullTapReport(
      productId: $productId
      testId: $testId
      taskId: $taskId
      mediaId: $mediaId
      testerId: $testerId
    ) {
      statusCode
      message
      data {
        x
        y
        order
        type
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetStudyFullTapReportQueryService extends Apollo.Query<
  GetStudyFullTapReportQuery,
  GetStudyFullTapReportQueryVariables
> {
  override document = GetStudyFullTapReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTapsReportDocument = gql`
  query getTapsReport(
    $productId: String!
    $testId: String!
    $taskId: String
    $testerId: String
    $mediaId: String
  ) {
    getTapsReport(
      testId: $testId
      productId: $productId
      taskId: $taskId
      testerId: $testerId
      mediaId: $mediaId
    ) {
      message
      statusCode
      data {
        HIT {
          percentage
          count
        }
        MISS {
          percentage
          count
        }
        TARGET {
          percentage
          count
        }
        total
        averageDuration
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTapsReportQueryService extends Apollo.Query<
  GetTapsReportQuery,
  GetTapsReportQueryVariables
> {
  override document = GetTapsReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetStudyTaskSuccessRateReportDocument = gql`
  query getStudyTaskSuccessRateReport($testId: String!, $productId: String!) {
    getStudyTaskSuccessRateReport(testId: $testId, productId: $productId) {
      message
      statusCode
      data {
        task {
          id
          description
        }
        statistics {
          successRate
          totalCount
          successCount
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetStudyTaskSuccessRateReportQueryService extends Apollo.Query<
  GetStudyTaskSuccessRateReportQuery,
  GetStudyTaskSuccessRateReportQueryVariables
> {
  override document = GetStudyTaskSuccessRateReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetVideoEmotionsReportDocument = gql`
  query getVideoEmotionsReport($testId: String!, $productId: String!) {
    getVideoEmotionsReport(testId: $testId, productId: $productId) {
      message
      statusCode
      data {
        testId
        emotions {
          angry
          disgust
          fear
          happy
          sad
          surprise
          neutral
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetVideoEmotionsReportQueryService extends Apollo.Query<
  GetVideoEmotionsReportQuery,
  GetVideoEmotionsReportQueryVariables
> {
  override document = GetVideoEmotionsReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestSessionReportDocument = gql`
  query getTestSessionReport(
    $productId: String!
    $page: Int = 1
    $filters: GetTestSessionReportInputs
  ) {
    getTestSessionReport(productId: $productId, filters: $filters, page: $page) {
      message
      statusCode
      data {
        data {
          ...TesterTestFragment
        }
        totalCount
        currentPage
      }
    }
  }
  ${TesterTestFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestSessionReportQueryService extends Apollo.Query<
  GetTestSessionReportQuery,
  GetTestSessionReportQueryVariables
> {
  override document = GetTestSessionReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTestDocument = gql`
  mutation createTest($data: CreateTestInputs!, $productId: String!) {
    createTest(data: $data, productId: $productId) {
      data {
        ...PureTestFragment
      }
      statusCode
      message
    }
  }
  ${PureTestFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTestMutationService extends Apollo.Mutation<
  CreateTestMutation,
  CreateTestMutationVariables
> {
  override document = CreateTestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestDocument = gql`
  query getTest($id: String!, $productId: String!) {
    getTest(productId: $productId, id: $id) {
      data {
        ...TestFragment
      }
      statusCode
      message
    }
  }
  ${TestFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestQueryService extends Apollo.Query<GetTestQuery, GetTestQueryVariables> {
  override document = GetTestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestsDocument = gql`
  query getTests($productId: String!, $page: Int = 1, $filters: GetTestsFilters) {
    getTests(productId: $productId, page: $page, filters: $filters) {
      data {
        data {
          ...TestFragment
        }
        totalCount
        currentPage
      }
      statusCode
      message
    }
  }
  ${TestFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestsQueryService extends Apollo.Query<GetTestsQuery, GetTestsQueryVariables> {
  override document = GetTestsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTestDocument = gql`
  mutation updateTest($id: String!, $productId: String!, $newData: UpdateTestInputs) {
    updateTest(id: $id, newData: $newData, productId: $productId) {
      data {
        ...PureTestFragment
      }
      statusCode
      message
    }
  }
  ${PureTestFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTestMutationService extends Apollo.Mutation<
  UpdateTestMutation,
  UpdateTestMutationVariables
> {
  override document = UpdateTestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteTestDocument = gql`
  mutation deleteTest($id: String!, $productId: String!) {
    deleteTest(id: $id, productId: $productId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteTestMutationService extends Apollo.Mutation<
  DeleteTestMutation,
  DeleteTestMutationVariables
> {
  override document = DeleteTestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const StartTestDocument = gql`
  mutation startTest($id: String!, $productId: String!) {
    startTest(id: $id, productId: $productId) {
      message
      statusCode
      data {
        ...PureTestFragment
      }
    }
  }
  ${PureTestFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class StartTestMutationService extends Apollo.Mutation<
  StartTestMutation,
  StartTestMutationVariables
> {
  override document = StartTestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AssignTestToTesterGroupDocument = gql`
  mutation assignTestToTesterGroup(
    $productId: String!
    $testId: String!
    $taskIds: [String]!
    $data: AssignTestToTesterGroupInputs
  ) {
    assignTestToTesterGroup(
      productId: $productId
      testId: $testId
      taskIds: $taskIds
      data: $data
    ) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AssignTestToTesterGroupMutationService extends Apollo.Mutation<
  AssignTestToTesterGroupMutation,
  AssignTestToTesterGroupMutationVariables
> {
  override document = AssignTestToTesterGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FinishTestDocument = gql`
  mutation finishTest($id: String!, $productId: String!) {
    finishTest(id: $id, productId: $productId) {
      message
      statusCode
      data {
        ...TestFragment
      }
    }
  }
  ${TestFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class FinishTestMutationService extends Apollo.Mutation<
  FinishTestMutation,
  FinishTestMutationVariables
> {
  override document = FinishTestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VerifyTestByPublicLinkDocument = gql`
  query verifyTestByPublicLink($code: String!) {
    verifyTestByPublicLink(code: $code) {
      message
      statusCode
      data {
        code
        status
        test {
          id
          name
          createdAt
          product {
            id
            name
            iconPath
          }
          tasks {
            id
            description
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class VerifyTestByPublicLinkQueryService extends Apollo.Query<
  VerifyTestByPublicLinkQuery,
  VerifyTestByPublicLinkQueryVariables
> {
  override document = VerifyTestByPublicLinkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSubscriptionPlansDocument = gql`
  query getSubscriptionPlans($filters: GetSubscriptionPlanFilters) {
    getSubscriptionPlans(filters: $filters) {
      message
      statusCode
      data {
        ...SubscriptionPlanListOutputFragment
        totalCount
        currentPage
      }
    }
  }
  ${SubscriptionPlanListOutputFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetSubscriptionPlansQueryService extends Apollo.Query<
  GetSubscriptionPlansQuery,
  GetSubscriptionPlansQueryVariables
> {
  override document = GetSubscriptionPlansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckoutDocument = gql`
  query checkout($subscriptionPlanId: String!) {
    checkout(subscriptionPlanId: $subscriptionPlanId) {
      message
      statusCode
      data {
        url
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckoutQueryService extends Apollo.Query<CheckoutQuery, CheckoutQueryVariables> {
  override document = CheckoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPaymentDocument = gql`
  query getPayment($paymentId: String!) {
    getPayment(paymentId: $paymentId) {
      message
      statusCode
      data {
        id
        invoiceNumber
        finalPrice
        status
        createdAt
        subscriptionPlan {
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPaymentQueryService extends Apollo.Query<
  GetPaymentQuery,
  GetPaymentQueryVariables
> {
  override document = GetPaymentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPaymentsDocument = gql`
  query getPayments($page: Int = 1) {
    getPayments(page: $page) {
      message
      statusCode
      data {
        totalCount
        currentPage
        data {
          id
          invoiceNumber
          invoiceId
          finalPrice
          status
          createdAt
          subscriptionPlan {
            name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPaymentsQueryService extends Apollo.Query<
  GetPaymentsQuery,
  GetPaymentsQueryVariables
> {
  override document = GetPaymentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetInvoiceDocument = gql`
  query getInvoice($invoiceId: String!) {
    getInvoice(invoiceId: $invoiceId) {
      message
      statusCode
      data
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetInvoiceQueryService extends Apollo.Query<
  GetInvoiceQuery,
  GetInvoiceQueryVariables
> {
  override document = GetInvoiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTestTaskDocument = gql`
  mutation createTestTask($productId: String!, $testId: String!, $data: CreateTestTaskInputs!) {
    createTestTask(data: $data, productId: $productId, testId: $testId) {
      data {
        ...TaskFragment
      }
      statusCode
      message
    }
  }
  ${TaskFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTestTaskMutationService extends Apollo.Mutation<
  CreateTestTaskMutation,
  CreateTestTaskMutationVariables
> {
  override document = CreateTestTaskDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteTestTaskDocument = gql`
  mutation deleteTestTask($id: String!, $productId: String!, $testId: String!) {
    deleteTestTask(id: $id, productId: $productId, testId: $testId) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteTestTaskMutationService extends Apollo.Mutation<
  DeleteTestTaskMutation,
  DeleteTestTaskMutationVariables
> {
  override document = DeleteTestTaskDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTestTaskDocument = gql`
  mutation updateTestTask(
    $id: String!
    $productId: String!
    $testId: String!
    $newData: UpdateTestTaskInputs
  ) {
    updateTestTask(id: $id, newData: $newData, productId: $productId, testId: $testId) {
      data {
        ...TaskFragment
      }
      statusCode
      message
    }
  }
  ${TaskFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTestTaskMutationService extends Apollo.Mutation<
  UpdateTestTaskMutation,
  UpdateTestTaskMutationVariables
> {
  override document = UpdateTestTaskDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestTaskDocument = gql`
  query getTestTask($id: String!, $productId: String!, $testId: String!) {
    getTestTask(id: $id, productId: $productId, testId: $testId) {
      data {
        ...TaskFragment
      }
      statusCode
      message
    }
  }
  ${TaskFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestTaskQueryService extends Apollo.Query<
  GetTestTaskQuery,
  GetTestTaskQueryVariables
> {
  override document = GetTestTaskDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GenerateTestTaskByAiDocument = gql`
  query generateTestTaskByAi($productId: String!, $testId: String!, $flowId: String!) {
    generateTestTaskByAi(productId: $productId, testId: $testId, flowId: $flowId) {
      message
      statusCode
      data
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GenerateTestTaskByAiQueryService extends Apollo.Query<
  GenerateTestTaskByAiQuery,
  GenerateTestTaskByAiQueryVariables
> {
  override document = GenerateTestTaskByAiDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestGroupDocument = gql`
  query getTestGroup($id: String!) {
    getTestGroup(id: $id) {
      data {
        ...TestGroupFragment
      }
      statusCode
      message
    }
  }
  ${TestGroupFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestGroupQueryService extends Apollo.Query<
  GetTestGroupQuery,
  GetTestGroupQueryVariables
> {
  override document = GetTestGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTestGroupDocument = gql`
  mutation createTestGroup($data: CreateTestGroupInputs!) {
    createTestGroup(data: $data) {
      data {
        ...TestGroupFragment
      }
      statusCode
      message
    }
  }
  ${TestGroupFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTestGroupMutationService extends Apollo.Mutation<
  CreateTestGroupMutation,
  CreateTestGroupMutationVariables
> {
  override document = CreateTestGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTestGroupDocument = gql`
  mutation updateTestGroup($id: String!, $newData: UpdateTestGroupInputs) {
    updateTestGroup(id: $id, newData: $newData) {
      data {
        ...TestGroupFragment
      }
      statusCode
      message
    }
  }
  ${TestGroupFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTestGroupMutationService extends Apollo.Mutation<
  UpdateTestGroupMutation,
  UpdateTestGroupMutationVariables
> {
  override document = UpdateTestGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteTestGroupDocument = gql`
  mutation deleteTestGroup($id: String!) {
    deleteTestGroup(id: $id) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteTestGroupMutationService extends Apollo.Mutation<
  DeleteTestGroupMutation,
  DeleteTestGroupMutationVariables
> {
  override document = DeleteTestGroupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestGroupsDocument = gql`
  query getTestGroups($page: Int = 1) {
    getTestGroups(page: $page) {
      data {
        data {
          ...TestGroupFragment
        }
        totalCount
        currentPage
      }
      statusCode
      message
    }
  }
  ${TestGroupFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestGroupsQueryService extends Apollo.Query<
  GetTestGroupsQuery,
  GetTestGroupsQueryVariables
> {
  override document = GetTestGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TesterUserFetchOrCreateDocument = gql`
  mutation testerUserFetchOrCreate($data: TesterUserFetchOrCreateInputs) {
    testerUserFetchOrCreate(data: $data) {
      data {
        ...TesterUserFragment
      }
      statusCode
      message
    }
  }
  ${TesterUserFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class TesterUserFetchOrCreateMutationService extends Apollo.Mutation<
  TesterUserFetchOrCreateMutation,
  TesterUserFetchOrCreateMutationVariables
> {
  override document = TesterUserFetchOrCreateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTestGroupMemberDocument = gql`
  mutation createTestGroupMember($data: CreateTestGroupMemberInputs) {
    createTestGroupMember(data: $data) {
      data {
        id
        testerUser {
          ...TesterUserFragment
        }
      }
      statusCode
      message
    }
  }
  ${TesterUserFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTestGroupMemberMutationService extends Apollo.Mutation<
  CreateTestGroupMemberMutation,
  CreateTestGroupMemberMutationVariables
> {
  override document = CreateTestGroupMemberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteGroupMemberDocument = gql`
  mutation deleteGroupMember($id: String!) {
    deleteTestGroupMember(id: $id) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteGroupMemberMutationService extends Apollo.Mutation<
  DeleteGroupMemberMutation,
  DeleteGroupMemberMutationVariables
> {
  override document = DeleteGroupMemberDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTestGroupMembersDocument = gql`
  query getTestGroupMembers($filters: GetTestGroupMembersFilters!, $page: Int = 1) {
    getTestGroupMembers(filters: $filters, page: $page) {
      data {
        data {
          id
          testerUser {
            ...TesterUserFragment
          }
        }
        totalCount
        currentPage
      }
      statusCode
      message
    }
  }
  ${TesterUserFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTestGroupMembersQueryService extends Apollo.Query<
  GetTestGroupMembersQuery,
  GetTestGroupMembersQueryVariables
> {
  override document = GetTestGroupMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTesterDocument = gql`
  query getTester($id: String!) {
    getTester(id: $id) {
      statusCode
      message
      data {
        ...TesterUserFragment
      }
    }
  }
  ${TesterUserFragmentFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTesterQueryService extends Apollo.Query<GetTesterQuery, GetTesterQueryVariables> {
  override document = GetTesterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateWorkspaceTesterDocument = gql`
  mutation createWorkspaceTester($data: CreateWorkspaceTesterInputs) {
    createWorkspaceTester(data: $data) {
      message
      statusCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateWorkspaceTesterMutationService extends Apollo.Mutation<
  CreateWorkspaceTesterMutation,
  CreateWorkspaceTesterMutationVariables
> {
  override document = CreateWorkspaceTesterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ResendTesterInvitationDocument = gql`
  mutation resendTesterInvitation($testId: String!, $productId: String!, $testerId: String!) {
    resendTesterInvitation(testId: $testId, productId: $productId, testerId: $testerId) {
      message
      statusCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ResendTesterInvitationMutationService extends Apollo.Mutation<
  ResendTesterInvitationMutation,
  ResendTesterInvitationMutationVariables
> {
  override document = ResendTesterInvitationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUploadPresignedUrlDocument = gql`
  query getUploadPresignedURL($data: GetUploadPresignedUrlInputs!, $type: FileUploadType) {
    getUploadPresignedURL(data: $data, type: $type) {
      data {
        url
        validFor
        key
      }
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUploadPresignedUrlQueryService extends Apollo.Query<
  GetUploadPresignedUrlQuery,
  GetUploadPresignedUrlQueryVariables
> {
  override document = GetUploadPresignedUrlDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateProfileDocument = gql`
  mutation updateProfile($newData: UpdateProfileInputs) {
    updateProfile(newData: $newData) {
      statusCode
      message
      data {
        at
        rt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateProfileMutationService extends Apollo.Mutation<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
> {
  override document = UpdateProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateWorkspaceDocument = gql`
  mutation updateWorkspace($newData: UpdateWorkspaceInputs) {
    updateWorkspace(newData: $newData) {
      message
      statusCode
      data {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateWorkspaceMutationService extends Apollo.Mutation<
  UpdateWorkspaceMutation,
  UpdateWorkspaceMutationVariables
> {
  override document = UpdateWorkspaceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWorkspaceStatisticsDocument = gql`
  query getWorkspaceStatistics {
    getWorkspaceStatistics {
      message
      statusCode
      data {
        product {
          count
          available
        }
        flow {
          count
          available
        }
        study {
          count
          available
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetWorkspaceStatisticsQueryService extends Apollo.Query<
  GetWorkspaceStatisticsQuery,
  GetWorkspaceStatisticsQueryVariables
> {
  override document = GetWorkspaceStatisticsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
